import { DatePipe } from '@angular/common';
import {
    Component,
    ElementRef,
    HostListener,
    NgZone,
    OnDestroy,
    QueryList,
    Renderer2,
    ViewChildren,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatMenuTrigger } from '@angular/material/menu';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as JSZip from 'jszip';
import { MessageService } from 'primeng/api';
import {
    Subject,
    debounceTime,
    distinctUntilChanged,
    filter,
    firstValueFrom,
    forkJoin,
    map,
    of,
    switchMap,
    takeUntil,
    tap,
} from 'rxjs';
import { PATHS as PATHSIRONSIDE } from 'src-ironside/app-routing.module';
import {
    EXPORT_OPTIONS,
    TEMPLATE_EXPORT_TYPES,
    functionToExportKey,
} from 'src-ironside/constants/export-product';
import { ExportOptionKey } from 'src-ironside/enums/resource.enum';
import { CategoryChecked, PageEvent } from 'src-ironside/interfaces/product.interface';
import { ModifyFavoriteComponent } from 'src-ironside/my-favourites/modify-favorite/modify-favorite';
import { TranslateDynamicLanguageTablePipe } from 'src-ironside/pipes/translateDynamicLanguageTable.pipe';
import { Brand } from 'src-ironside/repositories/brand.repository';
import { Category, CategoryRepository } from 'src-ironside/repositories/category.repository';
import { Filter } from 'src-ironside/repositories/common.repository';
import { ComparatorRepository } from 'src-ironside/repositories/comparator.repository';
import { Country } from 'src-ironside/repositories/country.repository';
import { Department } from 'src-ironside/repositories/department.repository';
import { Favorite, FavoriteRepository } from 'src-ironside/repositories/favorite.repository';
import { Packaging } from 'src-ironside/repositories/packaging.repository';
import { Partner } from 'src-ironside/repositories/partner.repository';
import {
    DynamicProductParam,
    Product,
    ProductExtendInfo,
    ProductFilter,
    ProductRepository,
} from 'src-ironside/repositories/product.repository';
import { Resource, ResourceRepository } from 'src-ironside/repositories/resource.repository';
import {
    DynamicReferencedFilterParam,
    Supplier,
} from 'src-ironside/repositories/supplier.repository';
import { TariffRepository } from 'src-ironside/repositories/tariff.repository';
import { RouterService } from 'src-ironside/router.service';
import { AccueilDataService } from 'src-ironside/services/accueil-data.service';
import { CommonService } from 'src-ironside/services/common.service';
import { PermissionService } from 'src-ironside/services/permission.service';
import { ScreenMediator, fromPATH } from 'src-ironside/services/screen.mediator';
import { SessionStorageService } from 'src-ironside/services/session-storage.service';
import { BreadCrumbItem } from 'src-ironside/shared/components/bread-crumb/bread-crumb.component';
import { LazyListCompontent } from 'src-ironside/shared/components/lazy-list-component';
import {
    buildCategoryHierarchyRandom,
    findCategoryLv1ByCategories,
    findCategoryLv1ByIds,
    flatCategories,
    getParamSearchFilters,
    getProductsInCategory,
    processInput,
} from 'src-ironside/utils/categories';
import { getCurrentDate } from 'src-ironside/utils/date.utils';
import { downloadAllResource } from 'src-ironside/utils/dowload-file-zip';
import { DynamicViewInfo } from 'src/app/shared/entities/dynamic-view';
import { TypeRequest } from 'src/app/shared/enums/type-request';
import { DynamicDocumentService } from 'src/app/shared/services/dynamic-document.service';
import { environment } from 'src/environments/environment.ironside';

@Component({
    selector: 'app-new-product',
    templateUrl: 'new-product.component.html',
    styleUrls: ['./new-product.component.css'],
    providers: [CategoryRepository, ProductRepository, ResourceRepository, MessageService],
})
export class NewProductComponent extends LazyListCompontent implements OnDestroy {
    @ViewChildren(MatMenuTrigger) favTriggers: QueryList<MatMenuTrigger>;
    @HostListener('document:click', ['$event']) onDocumentClick(event: any): void {
        if (this.exporterStautus) {
            if (
                event.target.className !== 'btn-common btn-modal' &&
                event.target.className !== 'exporter-item d-flex align-items-center'
            ) {
                this.exporterStautus = false;
            }
        }
    }

    readonly TypeRequest = TypeRequest;

    formFilter: FormGroup;
    formPagination!: FormGroup;
    exporterStautus = false;

    products?: Product[];
    categories: Category[];
    countries: Country[];
    partners: Partner[] = [];
    suppliers: Supplier[];
    departments: Department[];
    manufactoringCountry: Array<{ title: string; id: string; value: string }>;
    packagings: Packaging[];
    brands: Brand[];
    productsResult: Product[] = [];
    favorites: Favorite[];

    listRows = [10, 20, 30];
    first = 0;
    pageSize = 20;
    currentPage = 1;

    totalRecords = 0;

    rows: number = 1;

    destroyRef = new Subject();

    loadingExport = false;
    exportVisible = false;

    headerType: fromPATH;
    idSupplier: string;
    idMarque: string;
    researchValue = this.accueilDataService.filterData?.research || '';
    categoryName = this.sessionStorageService.getFilters()?.catalogName || '';
    categoryList = this.accueilDataService.filterData?.categoryList;
    categoryId = this.accueilDataService.filterData?.categoryId;
    favListName = this.sessionStorageService.getFilters()?.favListName ?? '';
    exportViews?: DynamicViewInfo[];
    startwithFilter: ProductFilter[];
    private destroy$: Subject<void> = new Subject<void>();
    private autoComplete$ = new Subject<void>();
    pathCurrentText?: string;

    progressNumber: number = 0;
    interval: any;
    visibleDialog: boolean = false;
    itemExportSelected: any[] = [];
    isProgress: boolean = false;
    exportOption = EXPORT_OPTIONS;

    isLoading: boolean = false;
    categoriesFlat: any[];
    progress: number;
    exportOptionKey = ExportOptionKey;

    isSupplierPanelCollapsed: boolean = true;
    isCategoryPanelCollapsed: boolean = false;
    isBrandPanelCollapsed: boolean = true;
    isManufacturingCountryPanelCollapsed: boolean = true;
    isPackagingPanelCollapsed: boolean = true;
    isDepartmentPanelCollapsed: boolean = true;
    isWithdrawnFromSalePanelCollapsed: boolean = true;
    isNewProductPanelCollapsed: boolean = true;
    isPartnerPanelCollapsed: boolean = true;
    isExportCancelled: boolean = false;
    cachedParentIds: string[] | null = null; // Cache parentIds để tái sử dụng
    categoriesChecked: {
        id: string[];
        code: string[];
    } = {
        id: this.sessionStorageService.getFilters()?.categories ?? [],
        code: [],
    };
    roleUser = localStorage.getItem('role');
    environment = environment;
    currentLang =
        environment.languagesExtranet.find((lang) => lang.code === this.translate.currentLang)
            ?.locale || 'en_GB';
    categoriesCheckedMap: { [id: string]: boolean } = {};
    fields = [
        'id',
        'longDescription',
        'shortDescription',
        'brand',
        'packaging',
        'standardNumberNf',
        'state',
        'linkToTariff',
        'linkToRessources',
        'description',
        'referenceProduct',
        'linkToParentProduct',
        'namePartner',
        'linkToTariff',
        'countryOfManufacture',
        'cutomsCode',
        'gencodeProduct',
        'specification',
        'typeOfProduct',
        'linkToCategories',
        'categoryCode',
        'department',
        'orderNumber',
        'statusProduct',
    ];

    @ViewChildren('lazyItem')
    set pItem(ql: QueryList<ElementRef>) {
        this.setLazyItems(ql);
    }

    constructor(
        private _fb: FormBuilder,
        public router: Router,
        private activatedRoute: ActivatedRoute,
        private renderer: Renderer2,
        private routerService: RouterService,
        private accueilDataService: AccueilDataService,
        private categoryRepository: CategoryRepository,
        private productRepository: ProductRepository,
        private screenMediator: ScreenMediator,
        private comparatorRepository: ComparatorRepository,
        private favoriteRepository: FavoriteRepository,
        private resourceRepository: ResourceRepository,
        public dialog: MatDialog,
        private dynamicDocumentService: DynamicDocumentService,
        public sessionStorageService: SessionStorageService,
        private _commonService: CommonService,
        private translate: TranslateService,
        private translateDynamicLanguage: TranslateDynamicLanguageTablePipe,
        private ngZone: NgZone,
        private _messageService: MessageService,
        private datePipe: DatePipe,
        public permissionService: PermissionService
    ) {
        super();
        window.scrollTo(0, 0);
        this.pathCurrentText = this.activatedRoute.snapshot.routeConfig?.path;
        switch (this.pathCurrentText) {
            case 'new-product':
                const dataFilter: any = {
                    isNewProduct: true,
                };
                this.accueilDataService.filterData = dataFilter;
                this.sessionStorageService.setFilters(dataFilter);
                break;

            case 'research':
                if (
                    /* fix search home page auto set isNewProduct */
                    /*                     !this.accueilDataService?.filterData?.hasOwnProperty('isNewProduct') ||
                     */ !this.sessionStorageService.getFilters().hasOwnProperty('isNewProduct')
                ) {
                    const dataSession = this.sessionStorageService.getFilters();
                    this.sessionStorageService.setFilters({ ...dataSession, isNewProduct: false });
                }
                break;

            default:
                if (
                    this.accueilDataService?.filterData?.hasOwnProperty('isNewProduct') ||
                    this.sessionStorageService?.getFilters()?.hasOwnProperty('isNewProduct')
                ) {
                    const dataSession = this.sessionStorageService.getFilters();
                    this.sessionStorageService.setFilters({ ...dataSession, isNewProduct: false });
                }
                break;
        }

        this.headerType = this.activatedRoute.snapshot.data['from'];
        this.initForm();
        this.setQueryParamFilter();
        this.getFilterFromUrl();
        if (this.headerType === fromPATH.header) {
            //menu
            this.screenMediator.clearHistory();
            this.screenMediator.putHistory({ name: 'Produits', url: 'new-product' });
        }

        if (this.headerType === fromPATH.supplier) {
            //supplier
            if (this.activatedRoute.snapshot.paramMap.get('supplierId')) {
                this.idSupplier = this.activatedRoute.snapshot.paramMap.get('supplierId')!;
                this.formFilter.patchValue({ suppliers: [this.idSupplier] });
            }
        }

        this.router.routeReuseStrategy.shouldReuseRoute = function () {
            return false;
        };

        this.router.events.pipe(takeUntil(this.destroy$)).subscribe((evt) => {
            if (evt instanceof NavigationEnd) {
                this.router.navigated = false;
                window.scrollTo(0, 0);
            }
        });

        if (this.headerType === fromPATH.marque) {
            this.activatedRoute.params.pipe(takeUntil(this.destroyRef)).subscribe((params) => {
                if (params['marqueId']) {
                    this.idMarque = params['marqueId'];
                    if (this.brands) {
                        const result = this.brands?.filter((el) => el.value === this.idMarque);
                        this.formFilter?.get('brand')?.patchValue([result?.[0]?.id]);
                    } else {
                        this._commonService
                            .getBrandStore()
                            .pipe(takeUntil(this.destroyRef))
                            .subscribe((res) => {
                                const result = res?.filter((el: any) => el.value === this.idMarque);
                                this.formFilter?.get('brand')?.patchValue([result?.[0]?.id]);
                            });
                    }
                }
            });
        }

        this.formFilter.valueChanges
            .pipe(
                debounceTime(600),
                distinctUntilChanged((prev, curr) => {
                    return JSON.stringify(prev) === JSON.stringify(curr);
                })
            )
            .pipe(takeUntil(this.destroyRef))
            .subscribe((res) => {
                this.getListProduct();
                this.sessionStorageService.setFilters(this.formFilter);
                this.itemExportSelected = [];
                this.setQueryParamFilter();
                const filterStore = this.sessionStorageService.getFilters();
                if (
                    (filterStore?.research && filterStore?.research?.length) ||
                    filterStore?.isNewProduct === true ||
                    (filterStore?.suppliers && filterStore.suppliers?.length > 0) ||
                    (filterStore?.brand && filterStore.brand?.length > 0)
                ) {
                    if (
                        (!this.sessionStorageService.getFilters()?.favListId &&
                            !this.sessionStorageService.getFilters()?.categoryList) ||
                        (this.sessionStorageService.getFilters()?.favListId?.length == 0 &&
                            !this.sessionStorageService.getFilters()?.categoryList)
                    ) {
                        this.getCategoriesByFilter();
                    }
                } else {
                    if (
                        !this.sessionStorageService?.getFilters()?.favListId ||
                        this.sessionStorageService?.getFilters()?.favListId?.length == 0
                    ) {
                        this.getCategories();
                    }
                }
            });

        this._commonService
            .getDepartmentStore()
            .pipe(takeUntil(this.destroyRef))
            .subscribe((res) => {
                this.departments = res;
            });
    }
    ngOnDestroy(): void {
        this.destroyRef.next(null);
        this.destroyRef.complete();
        this.destroy$.next();
        this.destroy$.complete();

        //this.resetCategories();
    }

    ngOnInit() {
        const body = document.querySelector('body');
        this.renderer.removeClass(body, 'overlay');
        //this.getPackagingsAndBrandsAndDepartments();
        /*  setTimeout(() => {
            this.getListProduct();
        }, 0); */
        if (!this.sessionStorageService.getFilters()?.isfavLis) {
            this.getListProduct();
        }

        this.getCountries();
        this.getPartners();
        this.getSuppliers();
        this.getFavorites();
        //this.getDepartments();

        this.autoComplete$
            .pipe(debounceTime(300))
            .pipe(takeUntil(this.destroyRef))
            .subscribe(() => {
                this.autoComplete(this.researchValue);
            });

        this.startwithFilter = this.getCurrentFilters();

        const filters = this.sessionStorageService.getFilters();
        if (filters?.favListId && filters?.favListId?.length > 0) {
            const {
                categories,
                suppliers,
                brand,
                manufactoringCountry,
                isNewProduct,
                isOffMarketProduct,
                departments,
                packaging,
                partners,
                ...newObjValue
            } = filters;

            this.sessionStorageService.setFilters(newObjValue);

            const fieldsToKeep = ['favListId', 'favListName', 'isfavLis', 'productIdsFav'];
            this.resetFormKeepSpecificFields(fieldsToKeep);
        }

        /** Function Permission - If want add more Case, please change if to switch case */
        this._commonService.getExtranetRestrictionsStore().subscribe((res) => {
            let isPermissionImg = res?.fonctions?.includes('export-images') ?? true;
            if (!isPermissionImg) {
                this.exportOption.forEach((el) => {
                    switch (el.key) {
                        case 'PHOTO':
                            el.permission = false;
                            break;

                        case 'PHOTO_THUMBNAIL':
                            el.permission = false;
                            break;

                        default:
                            break;
                    }
                });
            }

            Object.entries(functionToExportKey).forEach(([fonctionKey, exportKey]) => {
                this.updateExportPermission(res?.fonctions, fonctionKey, exportKey);
            });
        });

        const checkedIds = this.sessionStorageService.getFilters()?.categories ?? [];
        checkedIds.forEach((id: string) => {
            this.categoriesCheckedMap[id] = true;
        });
    }

    updateExportPermission(fonctions: string[], ref: string, key: string): void {
        const hasPermission = fonctions?.includes(ref) ?? true;
        this.exportOption.forEach((el) => {
            if (el.key === key) {
                el.permission = hasPermission;
            }
        });
    }

    setQueryParamFilter() {
        let filter = this.sessionStorageService.getFilters();
        this.formFilter.patchValue(filter);
        if (filter) {
            const result = Object.fromEntries(
                Object.entries(filter).filter(
                    ([_, value]) => value != null && (typeof value !== 'string' || value.length > 0)
                )
            );
            const currentQueryParams: any = this.activatedRoute.snapshot.queryParams;

            if (JSON.stringify(currentQueryParams.filter) !== JSON.stringify(result)) {
                const newUrl = this.buildUrlWithNewParams(result);

                window.history.replaceState({}, '', newUrl);
            }
        }
    }

    buildUrlWithNewParams(filter: any): string {
        const currentUrl = window.location.pathname;
        const queryParams = new URLSearchParams(window.location.search);

        queryParams.set('filter', JSON.stringify(filter));

        return `${currentUrl}?${queryParams.toString()}`;
    }

    getFilterFromUrl() {
        const queryParams: any = this.activatedRoute.snapshot.queryParams;

        if (queryParams.filter) {
            try {
                const filterFromUrl = JSON.parse(queryParams.filter);
                this.formFilter.patchValue(filterFromUrl);
                this.sessionStorageService.setFilters(filterFromUrl);
            } catch (e) {
                console.error('Error parsing filter from URL', e);
            }
        }
    }
    initForm(): void {
        const filterStore = this.sessionStorageService.getFilters();

        this.formFilter = this._fb.group({
            categories: [this.accueilDataService.filterData?.categories || []],
            research: [this.accueilDataService.filterData?.research || ''],
            suppliers: [this.accueilDataService.filterData?.suppliers || []],
            brand: [this.idMarque || ''],
            manufactoringCountry: [this.accueilDataService.filterData?.manufactoringCountry || []],
            isNewProduct: [this.accueilDataService.filterData?.isNewProduct ?? false],
            isOffMarketProduct: [false],
            departments: [this.accueilDataService.filterData?.departments || []],
            createDate: [this.accueilDataService.filterData?.createDate || ''],
            partners: [this.accueilDataService.filterData?.partners || []],
            packaging: [this.accueilDataService.filterData?.packaging || []],
            isCategoryModal: [filterStore?.isCategoryModal],
            categoryList: [filterStore?.categoryList || []],
            isfavLis: [filterStore?.isfavLis],
            favListName: [filterStore?.favListName || ''],
            favListId: [filterStore?.favListId || ''],
            productIdsFav: [filterStore?.productIdsFav || []],
            catalogName: [filterStore?.catalogName || ''],
        });

        this.formPagination = this._fb.group({
            rows: [20],
        });

        if (
            (filterStore?.research && filterStore?.research?.length) ||
            filterStore?.isNewProduct === true ||
            (filterStore?.suppliers && filterStore.suppliers?.length > 0) ||
            (filterStore?.brand && filterStore.brand?.length > 0)
        ) {
            if (
                (!this.sessionStorageService.getFilters()?.favListId &&
                    !this.sessionStorageService.getFilters()?.categoryList) ||
                (this.sessionStorageService.getFilters()?.favListId?.length == 0 &&
                    !this.sessionStorageService.getFilters()?.categoryList)
            ) {
                this.getCategoriesByFilter();
            }
        } else {
            /* NO Favorits */
            if (
                (!this.sessionStorageService.getFilters()?.favListId ||
                    this.sessionStorageService.getFilters()?.favListId?.length == 0) &&
                this.sessionStorageService.getFilters()?.categoryList
            ) {
                this.getCategories();
            }
        }

        if (this.sessionStorageService.getFilters()?.isfavLis) {
            this.getCategoriesByFilter();
        }
    }

    autoComplete(term: string) {
        if (term.length >= 3) {
            this.productRepository
                .find(
                    [{ fieldName: 'referenceProduct', values: [this.researchValue] }],
                    1,
                    5,
                    'DESC'
                )
                .pipe(takeUntil(this.destroyRef))
                .subscribe((res: any) => {
                    this.productsResult = res.content;
                });
        }
    }

    onPageChange(event: PageEvent) {
        this.first = event.first;
        this.currentPage = event.page + 1;

        this.getListProduct();
        window.scrollTo(0, 0);
    }

    delStatus(code: number): void {
        const currentValue =
            this.formFilter.get('partners')?.value?.filter((value: any) => value !== code) || [];

        this.formFilter.get('partners')?.patchValue(currentValue);
    }

    delBrand(code: number): void {
        const currentValue =
            this.formFilter.get('brand')?.value?.filter((value: any) => value !== code) || [];

        this.formFilter.get('brand')?.patchValue(currentValue);
    }

    /* DELETE SUB TAG */
    delSupplier(code: number): void {
        const currentValue =
            this.formFilter.get('suppliers')?.value?.filter((value: any) => value !== code) || [];

        this.formFilter.get('suppliers')?.patchValue(currentValue);
    }

    /* DELETE ManuFactory */
    delManufactoring(code: number): void {
        const currentValue =
            this.formFilter
                .get('manufactoringCountry')
                ?.value?.filter((value: any) => value !== code) || [];

        this.formFilter.get('manufactoringCountry')?.patchValue(currentValue);
    }

    delCategory(id: string): void {
        const flat = flatCategories(this.categories);
        const category = flat.find((cat: Category) => cat.id === id);
        if (!category) return;

        const selected = this.categoriesChecked.id;

        // Nếu là cha, xóa cả cha và các con
        if (!category.parentId) {
            const children = flat
                .filter((catParent: any) => catParent.parentId === id)
                .map((item: any) => item.id);
            this.categoriesChecked.id = selected.filter(
                (el) => el !== id && !children.includes(el)
            );
        }
        // Nếu là con → chỉ xóa con
        else {
            this.categoriesChecked.id = selected.filter((el) => el !== id);
        }

        this.formFilter.get('categories')?.patchValue(this.categoriesChecked.id);
    }

    /* DELETE  */
    delPackaging(code: number): void {
        const currentValue =
            this.formFilter.get('packaging')?.value?.filter((value: any) => value !== code) || [];

        this.formFilter.get('packaging')?.patchValue(currentValue);
    }

    delWithdrawnFromSaleValue(): void {
        this.formFilter.get('isOffMarketProduct')?.patchValue(false);
    }

    /* New Product */
    delNewProductValue(): void {
        this.formFilter.get('isNewProduct')?.patchValue(false);
    }

    delDepartment(code: number): void {
        const currentValue =
            this.formFilter.get('departments')?.value?.filter((value: any) => value !== code) || [];

        this.formFilter.get('departments')?.patchValue(currentValue);
    }

    resetFormKeepSpecificFields(fieldsToKeep: string[]) {
        /*  const fieldsToKeep = ; */
        const currentValues = fieldsToKeep.reduce((acc, field) => {
            acc[field] = this.formFilter.get(field)?.value;
            return acc;
        }, {} as any);

        this.formFilter.reset();

        fieldsToKeep.forEach((field) => {
            this.formFilter.get(field)?.setValue(currentValues[field]);
        });
    }

    clearFilter(): void {
        this.researchValue = '';
        const filter = this.sessionStorageService.getFilters();
        const hasCategoryModal = this.sessionStorageService
            .getFilters()
            .hasOwnProperty('isCategoryModal');

        if (this.headerType === fromPATH.supplier) {
            const fieldsToKeep = ['suppliers'];
            this.resetFormKeepSpecificFields(fieldsToKeep);
            this.resetAllChecked();
        } else if (hasCategoryModal) {
            this.resetAllChecked();
            Object.keys(this.categoriesCheckedMap).forEach((id) => {
                this.categoriesCheckedMap[id] = true;
            });
            const fieldsToKeep = ['categories', 'categoryList', 'isCategoryModal', 'catalogName'];
            this.resetFormKeepSpecificFields(fieldsToKeep);
        } else if (filter?.favListId) {
            const { favListId, favListName, isfavLis, productIdsFav, ...obj } = filter;
            this.sessionStorageService.setFilters({
                favListId: favListId,
                favListName: favListName,
                isfavLis: isfavLis,
                productIdsFav: productIdsFav,
            });
            // Reset the form but keep specific fields
            const fieldsToKeep = ['favListId', 'favListName', 'isfavLis', 'productIdsFav'];
            this.resetFormKeepSpecificFields(fieldsToKeep);
            this.resetAllChecked();
        } else {
            this.resetAllChecked();
            this.formFilter.reset();
        }

        this.startwithFilter.map((el) => {
            switch (el.fieldName) {
                case 'categoryCode.documentId':
                    this.formFilter.get('categories')?.setValue(el.values);
                    break;

                case 'new':
                    this.formFilter.get('isNewProduct')?.setValue(el.values);
                    break;
            }
        });
    }

    filterRows(event: any): void {
        this.pageSize = this.formPagination.value.rows || 20;
        this.getListProduct();
        window.scrollTo(0, 0);
    }

    selectCategory(category: Category) {
        if (!category) {
            return;
        }

        const curentFilter: any = this.sessionStorageService?.getFilters();

        if (curentFilter) {
            this.sessionStorageService.setFilters({
                ...curentFilter,
                codeCategory: category.codeCategory,
            });
            this.formFilter.get('categories')?.patchValue(category?.id);
        }
    }

    public removeFromFavorites(p: Product) {
        if (!p.id) return;

        if (p.isFavorite) {
            p.isFavorite = false;
            this.favoriteRepository.unFavorite(p.id);
            const filter: any = this.sessionStorageService.getFilters();
            if (filter?.isfavLis) {
                this.products = this.products?.filter((el) => el.id !== p.id);
            }
        }
    }

    addToFavorites(favId: string, product: Product) {
        if (!product?.id) return;
        product.isFavorite = true;
        this.favoriteRepository.favorite(favId, product.id);
    }

    checkHasFavorites(index: number) {
        if (this.favoriteRepository.favorites?.length === 0) {
            this.favTriggers.toArray()[index].closeMenu();

            const dialogRef = this.dialog.open(ModifyFavoriteComponent);
            dialogRef.componentInstance.onClose
                .asObservable()
                .pipe(
                    tap((res) => {
                        if (res) {
                            this.getFavorites();
                        }
                    })
                )
                .subscribe();
        }
    }

    onOpenDialog(product: Product) {
        const dialogRef = this.dialog.open(ModifyFavoriteComponent);
        dialogRef.componentInstance.onClose
            .asObservable()
            .pipe(
                tap((res) => {
                    if (res) {
                        this.addToFavorites(res?.id, product);
                    }
                })
            )
            .subscribe(() => {
                this.getFavorites();
            });
    }

    dropdownExporter(): void {
        if (!this.exportViews) {
            this.productRepository
                .getViews()
                .pipe(takeUntil(this.destroyRef))
                .subscribe((res) => {
                    this.exportViews = res;
                });
        }
        this.exporterStautus = !this.exporterStautus;
    }

    export(viewId: string) {
        this.productRepository.export(viewId, this.getCurrentFilters());
    }

    getTranslatedRoute(route?: string) {
        return this.routerService.getTranslatedRoute(route);
    }

    getCurrentFilters(): ProductFilter[] {
        const productFilters: ProductFilter[] = [];
        const filterStore = this.sessionStorageService.getFilters();
        if (filterStore?.isfavLis) {
            const condition =
                filterStore?.productIdsFav?.length > 0
                    ? filterStore?.productIdsFav
                    : ['00000000000000000000000'];
            if (condition.length > 0) {
                productFilters.push({
                    fieldName:
                        filterStore?.productIdsFav?.length > 0
                            ? 'linkToParentProduct.documentId'
                            : 'id',
                    values: condition,
                });
            }
        }
        /* Search */
        if (this.formFilter.value['research']) {
            const regex = /^(\d+[,\s]+)*\d+$/;
            /* Check isReference */
            const result = regex.test(this.formFilter.value['research'])
                ? processInput(this.formFilter.value['research']) ?? []
                : [this.formFilter.value['research']];

            productFilters.push({
                fieldName: 'referenceProduct',
                values: result,
            });
            productFilters.push({
                fieldName: 'longDescription',
                values: result,
            });

            productFilters.push({
                fieldName: 'shortDescription',
                values: result,
            });
        }

        if (this.formFilter.value['categories'] && this.formFilter.value.categories.length > 0) {
            /* const result = this.findNodeByCode(
                this.categoriesFlat,
                this.formFilter.value.categories
            );
            
            const conditon = this.extractValuesOrigin([result]); */
            const conditon = this.formFilter.value.categories;
            if (conditon.length > 0) {
                productFilters.push({
                    fieldName: 'categoryCode.documentId',
                    values: conditon,
                });
            }
        } else {
            const hasCategoryModal = this.sessionStorageService
                .getFilters()
                .hasOwnProperty('categoryList');
            if (this.categoryList && hasCategoryModal) {
                const conditon = this.extractValuesOrigin(this.categoryList);
                if (conditon.length > 0) {
                    productFilters.push({
                        fieldName: 'categoryCode.documentId',
                        values: conditon,
                    });
                }
            } else {
                const hasCategoryModal = this.sessionStorageService
                    .getFilters()
                    .hasOwnProperty('categoryList');
                let codeCategories: string[] = [];
                const isCategoryList = this.sessionStorageService.getFilters().categoryList;
                if (hasCategoryModal && isCategoryList?.length > 0) {
                    if (this.categories?.length) {
                        codeCategories = flatCategories(this.categories).map(
                            (el: Category) => el.id
                        );
                    }
                    productFilters.push({
                        fieldName: 'categoryCode.documentId',
                        values: codeCategories,
                    });
                }
            }
        }
        if (this.formFilter.value['partners'] && this.formFilter.value['partners']?.length > 0) {
            productFilters.push({
                fieldName: 'linkToPartnerReference.value.documentId',
                values: this.formFilter.value['partners'],
            });
        }
        if (this.formFilter.value['createDate']) {
            productFilters.push({
                fieldName: 'creationDate',
                values: [this.formFilter.value['createDate']],
            });
        }
        if (
            this.formFilter.value['departments'] &&
            this.formFilter.value['departments']?.length > 0
        ) {
            productFilters.push({
                fieldName: 'department.parameterId',
                values: this.formFilter.value['departments'],
            });
        }
        if (
            this.formFilter.value['isOffMarketProduct'] !== undefined &&
            this.formFilter.value['isOffMarketProduct'] !== null &&
            this.formFilter.value['isOffMarketProduct'] !== false
        ) {
            productFilters.push({
                fieldName: 'state.parameterId',
                values: ['65e595e54a6e8e68b5c66805'],
            });
        }
        if (
            this.formFilter.value['isNewProduct'] !== undefined &&
            this.formFilter.value['isNewProduct'] !== null &&
            this.formFilter.value['isNewProduct'] !== false
        ) {
            productFilters.push({
                fieldName: 'new',
                values: [this.formFilter.value['isNewProduct']],
            });
        }
        if (
            this.formFilter.value['manufactoringCountry'] &&
            this.formFilter.value['manufactoringCountry']?.length > 0
        ) {
            productFilters.push({
                fieldName: 'countryOfManufacture.parameterId',
                values: this.formFilter.value['manufactoringCountry'],
            });
        }
        if (this.formFilter.value['brand'] && this.formFilter.value['brand']?.length > 0) {
            productFilters.push({
                fieldName: 'brand.parameterId',
                values: this.formFilter.value['brand'],
            });
        }
        if (this.formFilter.value['suppliers'] && this.formFilter.value['suppliers']?.length > 0) {
            productFilters.push({
                fieldName: 'linkToSupplier.documentId',
                values: this.formFilter.value['suppliers'],
            });
        }

        if (this.formFilter.value['packaging'] && this.formFilter.value['packaging']?.length > 0) {
            productFilters.push({
                fieldName: 'packaging.parameterId',
                values: this.formFilter.value['packaging'],
            });
        }
        return productFilters;
    }

    findNodeByCode(tree: Category[], code: string): any | null {
        if (!tree) return null;

        for (const node of tree) {
            if (node?.id === code) {
                return node;
            }

            if (node?.subcategoryList) {
                const foundNode = this.findNodeByCode(node.subcategoryList, code);
                if (foundNode) {
                    return foundNode;
                }
            }
        }

        return null;
    }

    findNodesByCodes(tree: Category[], codes: string[]) {
        if (!tree || !codes || codes.length === 0) return [];
        const result: Category[] = [];
        for (const code of codes) {
            const node = this.findNodeByCode(tree, code);
            if (node) {
                const existingParent = result.find(
                    (item) => item.codeCategory === node.codeCategory
                );
                if (existingParent) {
                    existingParent.subcategoryList = [
                        ...existingParent.subcategoryList,
                        ...node.subcategoryList,
                    ];
                } else {
                    result.push(node);
                }
            }
        }

        return result;
    }

    getFieldFilter(fieldName: string, value: any[]) {
        return {
            fieldName: fieldName,
            conditions: [
                {
                    type: value?.length > 1 ? 'IN' : 'EQUALS',
                    value: value?.length > 1 ? value : value[0],
                },
            ],
        };
    }

    getBodyFilters() {
        const filter = this.getCurrentFilters();
        return {
            filters: this.convertFilterProduct(filter),
            fields: this.fields,
            locales: [
                environment.languagesExtranet.find(
                    (lang: any) => lang?.code === this.translate.currentLang
                )?.locale || 'en_GB',
            ],
            sorts: {
                /*  referenceProduct: 'DESC', publishedOrder: 'DESC' */
            },
            page: this.currentPage,
            pageSize: this.pageSize,
        };
    }

    getListProduct() {
        this.isLoading = true;
        let body: DynamicProductParam;
        this._commonService
            .getCategories()
            .pipe(
                filter((el) => el && el.length > 0),
                switchMap((el) => {
                    /* this.categoryName = el.find(
                        (item: any) => item?.codeCategory === this.formFilter?.value?.categories
                    )?.nameCategory?.fr_FR; */

                    this.categoriesFlat = el;
                    body = this.getBodyFilters();

                    return this.dynamicDocumentService.searchDynamicProductList(body).pipe(
                        map((res) => ({
                            content: res?.content
                                ?.map((product) =>
                                    this.productRepository.convertProductOriginalLanguage(product)
                                )
                                .filter((el: any) => el.statusProduct?.value === 'VALIDE'),
                            meta: {
                                pageSize: res?.size,
                                totalPages: res?.totalPages,
                                totalItems: res?.totalElements,
                            },
                        }))
                    );
                })
            )
            .pipe(takeUntil(this.destroyRef))
            .subscribe({
                next: (res: any) => {
                    this.products = res.content;
                    const idsParentItem: string[] = this.products?.map((el: any) => el.id) ?? [];
                    this.handleGetResourceParentById(idsParentItem);

                    let result: Category[] = [];
                    if (!this.categories?.length) {
                        const listCategories = this.products!.map(
                            (el: Product) => el?.categoryOrigin?.documentId
                        ).filter((id: string) => id !== undefined);
                        this._commonService
                            .getFlatCategories()
                            .pipe(takeUntil(this.destroyRef))
                            .subscribe((tree) => {
                                let treeFilter = [];
                                let treeResult = [];
                                if (
                                    this.sessionStorageService.getFilters()?.categoryList?.length >
                                    0
                                ) {
                                    treeFilter =
                                        this.sessionStorageService.getFilters()?.categories;
                                    treeResult = findCategoryLv1ByIds(tree, treeFilter);
                                } else {
                                    treeFilter = tree?.filter((el: any) =>
                                        listCategories.includes(el.id)
                                    );
                                    treeResult = findCategoryLv1ByCategories(tree, treeFilter);
                                }

                                result = buildCategoryHierarchyRandom(treeResult);

                                this.categories = result.sort((a: any, b: any) =>
                                    a.nameCategory?.[this.currentLang].localeCompare(
                                        b.nameCategory?.[this.currentLang]
                                    )
                                );
                                //this.getCategoriesByFilter();
                            });
                    }
                    this.products?.forEach((product) => {
                        if (product.id)
                            product.isFavorite = this.favoriteRepository.isFavorited(product.id);
                    });

                    this.totalRecords = res.meta.totalItems;
                    this.handleLoadLazyData(body);
                    this.isLoading = false;
                    this.getPackagingsAndBrandsAndDepartments();
                    this.handleShowMarqueAndPackagingProduct(
                        this.packagings,
                        this.brands,
                        this.departments
                    );
                    if (this.products?.length) {
                        /* this.products?.forEach((product: any) => {
                            product.department = this.departments?.filter(
                                (el) => product.department?.[0]?.parameterId == el.id
                            )?.[0]?.title;
                        }); */
                        // Load resource quantities từ API sau khi có products
                        this.loadResourceQuantities();
                    }
                },
                error: () => {
                    this.isLoading = false;
                },
            });
    }

    handleGetResourceParentById(idsParentItem: string[]) {
        const filter = {
            fieldName: 'id',
            conditions: idsParentItem?.map((value) => ({
                type: 'EQUALS',
                value: value,
            })),
        };

        const body = {
            filters: [filter],
            fields: [],
            locales: [this.currentLang],
            sorts: {
                referenceProduct: 'DESC',
                publishedOrder: 'DESC',
            },
        };

        this.dynamicDocumentService.getResourceParentById(body).subscribe((res) => {
            const resourceActive = res?.map((item: any) => {
                item.fullResources = item.fullResources?.filter(
                    (el: any) =>
                        el.status?.value === 'ACTIF' && el.typeOfResource?.value === 'PHOTO'
                );
                return item;
            });

            this.products = this.products?.map((product: any) => {
                product.resourceParent = resourceActive?.find(
                    (el: any) => product.id === el.id
                )?.fullResources;
                return product;
            });
        });
    }

    /* Convert data filters to APIs standards */
    public convertFilterProduct(productFilters: ProductFilter[], isExport?: boolean) {
        // Nếu là export, chỉ lấy 3 fieldName được phép
        const allowedFieldsForExport = [
            'linkToSupplier.documentId',
            'linkToParentProduct.documentId',
            'childProduct.documentId',
        ];

        if (isExport) {
            const filterProducts: Filter[] = [];
            productFilters?.forEach((filter: ProductFilter) => {
                if (allowedFieldsForExport.includes(filter.fieldName)) {
                    if (filter.fieldName === 'linkToParentProduct.documentId') {
                        filterProducts.push({
                            fieldName: filter.fieldName,
                            conditions: [
                                {
                                    type: 'IN',
                                    value: filter.values,
                                },
                            ],
                        });
                    } else {
                        filterProducts.push({
                            fieldName: filter.fieldName,
                            conditions: Array.isArray(filter.values)
                                ? filter.values.map((value) => ({
                                      type: 'EQUALS',
                                      value: value,
                                  }))
                                : [
                                      {
                                          type: 'EQUALS',
                                          value: filter.values,
                                      },
                                  ],
                        });
                    }
                }
            });
            return filterProducts;
        }

        const isReferenceProduct = productFilters?.some(
            (item) => item?.fieldName === 'referenceProduct'
        );
        let defaultFilters: Filter[] = [
            {
                fieldName: isReferenceProduct ? 'statusProduct' : 'statusProduct.parameterId',
                conditions: [
                    {
                        type: 'EQUALS',
                        value: isReferenceProduct ? 'VALIDE' : '65e58fd64a6e8e68b5c667e5',
                    },
                ],
            },
        ];
        const filterProducts: Filter[] = [...defaultFilters];
        productFilters?.forEach((filter: ProductFilter) => {
            if (filter.fieldName === 'new') {
                filterProducts.push(
                    {
                        fieldName: 'newStartDate',
                        conditions: [
                            {
                                type: 'LESS_THAN',
                                value: getCurrentDate(),
                            },
                        ],
                    },
                    {
                        fieldName: 'newEndDate',
                        conditions: [
                            {
                                type: 'GREATER_THAN',
                                value: getCurrentDate(),
                            },
                        ],
                    },
                    {
                        fieldName: 'new',
                        conditions: [
                            {
                                type: 'EQUALS',
                                value: true,
                            },
                        ],
                    }
                );
            } else if (filter.fieldName === 'linkToParentProduct.documentId') {
                filterProducts.push({
                    fieldName: filter.fieldName,
                    conditions: [
                        {
                            type: 'IN',
                            value: filter.values,
                        },
                    ],
                });
            } else if (
                ['referenceProduct', 'longDescription', 'shortDescription'].includes(
                    filter.fieldName
                )
            ) {
                if (filter.fieldName === 'referenceProduct') {
                    filterProducts.push({
                        fieldName: filter.fieldName,
                        operator: 'AND',
                        conditions: filter.values.map((value) => ({
                            type: 'CONTAINS',
                            value: value,
                        })),
                    });
                } else if (filter.fieldName === 'id') {
                    filterProducts.push({
                        fieldName: filter.fieldName,
                        conditions: filter.values.map((value) => ({
                            type: 'CONTAINS',
                            value: value,
                        })),
                    });
                } else {
                    filterProducts.push({
                        fieldName: filter.fieldName,
                        operator: 'OR',
                        conditions: filter.values.map((value) => ({
                            type: 'CONTAINS',
                            value: value,
                        })),
                    });
                }
            } else {
                filterProducts.push({
                    fieldName: filter.fieldName,
                    conditions: Array.isArray(filter.values)
                        ? filter.values.map((value) => ({
                              type: 'EQUALS',
                              value: value,
                          }))
                        : [
                              {
                                  type: 'EQUALS',
                                  value: filter.values,
                              },
                          ],
                });
            }
        });
        return filterProducts;
    }

    getCategories() {
        const hasCategoryModal = this.sessionStorageService
            .getFilters()
            .hasOwnProperty('isCategoryModal');
        if (hasCategoryModal === true) {
            if (Array.isArray(this.categoryList) && this.categoryList.length > 0) {
                this.categories = this.categoryList.sort(
                    (a: any, b: any) =>
                        a.nameCategory?.[this.currentLang].localeCompare(
                            b.nameCategory?.[this.currentLang]
                        ) ?? []
                );
            } else {
                this._commonService
                    .getCategories()
                    .pipe(filter((el) => el && el.length !== undefined))
                    .pipe(takeUntil(this.destroyRef))
                    .subscribe((res) => {
                        const result = this.findNodesByCodes(
                            res,
                            this.sessionStorageService.getFilters().categoryList
                        );
                        this.categories = this.categoriesFlat = result.sort(
                            (a: any, b: any) =>
                                a.nameCategory?.[this.currentLang].localeCompare(
                                    b.nameCategory?.[this.currentLang]
                                ) ?? []
                        );
                    });
            }
        } else if (hasCategoryModal === false) {
            this.categoryRepository
                .findOriginal(3)
                .pipe(takeUntil(this.destroyRef))
                .subscribe((res: any) => {
                    const result = buildCategoryHierarchyRandom(res?.content);
                    this.categories = getProductsInCategory(result).sort(
                        (a: any, b: any) =>
                            a.nameCategory?.[this.currentLang].localeCompare(
                                b.nameCategory?.[this.currentLang]
                            ) ?? []
                    );

                    this.categoriesFlat = res?.content;
                });
        }
    }

    getCountries() {
        const body: DynamicProductParam = this.getBodyFilters();
        this.dynamicDocumentService
            .getDataParameterCountByDocumentName(body, 'countries')
            .pipe(
                map((res) => {
                    return res
                        .map((el: any) => ({
                            id: el.id,
                            title: el?.country?.mapLocalLibelle,
                            value: el?.country?.valeur,
                        }))
                        .sort(
                            (a: any, b: any) =>
                                a.title?.[this.currentLang].localeCompare(
                                    b.title?.[this.currentLang]
                                ) ?? []
                        );
                }),
                takeUntil(this.destroyRef)
            )
            .subscribe((res) => {
                this.countries = res;
            });
    }

    getPartners() {
        const body: DynamicProductParam = this.getBodyFilters();

        this.dynamicDocumentService
            .getDataParameterCountByDocumentName(body, 'partners')
            .pipe(
                map((res) => {
                    return res
                        .filter((el: any) => el?.partnerStatusInfo?.valeur === 'ACTIF')
                        .map((el: any) => ({
                            count: el.count,
                            id: el.id,
                            title: el?.partner?.companyName,
                            code: el?.partner?.code,
                        }))
                        .sort((a: any, b: any) => a.title.localeCompare(b.title) ?? []);
                }),
                takeUntil(this.destroyRef)
            )
            .subscribe((res) => {
                this.partners = res;
            });
    }

    getSuppliers() {
        const body: DynamicProductParam = this.getBodyFilters();
        this.dynamicDocumentService
            .getDataParameterCountByDocumentName(body, 'suppliers')
            .pipe(
                map((res) => {
                    return res
                        .filter((el: any) => el?.supplierStatusInfo?.valeur === 'PUBLIE')
                        .map((el: any) => ({
                            id: el.id,
                            title: el?.supplier?.companyName,
                            phone: el?.supplier?.phone,
                            fax: el?.supplier?.fax,
                            email: el?.supplier?.email,
                            city: el?.supplier?.city,
                            code: el?.supplier?.code,
                            resources: el?.supplier?.linkToResources?.map(
                                (resource: any) => resource.documentId
                            ),
                            logo: el?.supplier?.logo?.[0]?.url,
                            count: el.count,
                        }))
                        .sort((a: any, b: any) => a.title.localeCompare(b.title));
                }),
                takeUntil(this.destroyRef)
            )
            .subscribe((res) => {
                this.suppliers = res;
            });
    }

    getPackagingsAndBrandsAndDepartments() {
        const body: DynamicProductParam = this.getBodyFilters();
        forkJoin([
            this.dynamicDocumentService.getDataParameterCountByDocumentName(body, 'packagings'),
            this.dynamicDocumentService.getDataParameterCountByDocumentName(body, 'brands'),
        ])
            .pipe(takeUntil(this.destroyRef))
            .subscribe((result) => {
                const [packagings, brands] = result;
                this.brands = brands
                    .map((item: any) => ({
                        id: item.id,
                        title: item?.brand?.mapLocalLibelle,
                        value: item?.brand?.valeur,
                        count: item.count,
                    }))
                    .sort(
                        (a: any, b: any) =>
                            a.title?.[this.currentLang].localeCompare(
                                b.title?.[this.currentLang]
                            ) ?? []
                    );
                this.packagings = packagings
                    .map((item: any) => ({
                        id: item.id,
                        title: item?.packaging?.mapLocalLibelle,
                        value: item?.packaging?.valeur,
                        count: item.count,
                    }))
                    .sort(
                        (a: any, b: any) =>
                            a.title?.[this.currentLang].localeCompare(
                                b.title?.[this.currentLang]
                            ) ?? []
                    );

                this.handleShowMarqueAndPackagingProduct(
                    this.packagings,
                    this.brands,
                    this.departments
                );
            });
    }

    handleShowMarqueAndPackagingProduct(
        packagings: Packaging[],
        brands: Brand[],
        departments: Department[]
    ) {
        if (this.products?.length) {
            this.products?.forEach((product) => {
                const packaging = packagings?.find(
                    (el) => product.packagingOrigin?.parameterId === el.id
                );
                const brand = brands?.find(
                    (el: any) => product.brandOrigin?.parameterId === el?.id
                );
                const department = departments?.find(
                    (el: any) => product.department?.[0]?.parameterId === el?.id
                );

                product.packaging = packaging ? packaging.title : product.packaging;
                product.brand = brand ? brand.title : product.brand;
                product.departmentOrigin = department ? department.title : product.categoryOrigin;
            });
        }
    }

    getFavorites() {
        this.favoriteRepository
            .getMyFavoriteList()
            .pipe(takeUntil(this.destroyRef))
            .subscribe((res) => {
                this.favorites = res;
            });
    }

    get partnersValue() {
        return this.formFilter?.get('partners')?.value;
    }

    get categoryFilter() {
        return this.sessionStorageService.getFilters().hasOwnProperty('categories');
    }

    /* GET VALUE SUB */
    get supplierValue() {
        return this.formFilter?.get('suppliers')?.value;
    }

    get brandValue() {
        return this.formFilter?.get('brand')?.value;
    }

    /* GET VALUE SUB */
    get manufactoringCountryValue() {
        return this.formFilter?.get('manufactoringCountry')?.value;
    }

    get packagingValue() {
        return this.formFilter?.get('packaging')?.value;
    }

    get departmentValue() {
        return this.formFilter?.get('departments')?.value;
    }

    get isWithdrawnFromSaleValue() {
        return this.formFilter?.get('isOffMarketProduct')?.value;
    }

    get isNewProductValue() {
        return this.formFilter?.get('isNewProduct')?.value == true;
    }

    get departmentValueOption() {
        const values = this.formFilter?.get('departments')?.value;
        if (values && values.length > 0) {
            const result = values?.map((el: string) => {
                return this.departments?.find((item) => el === item.id);
            });
            return result;
        }
    }

    get packagingValueOption() {
        const values = this.formFilter?.get('packaging')?.value;
        if (values && values.length > 0) {
            const result = values?.map((el: string) => {
                return this.packagings?.find((item) => el === item.id);
            });
            return result;
        }
    }

    get manufactoringCountryValueOption() {
        const values = this.formFilter?.get('manufactoringCountry')?.value;
        if (values && values.length > 0) {
            const result = values?.map((el: string) => {
                return this.countries?.find((item) => el === item.id);
            });
            return result;
        }
    }

    get brandValueOption() {
        const values = this.formFilter?.get('brand')?.value;
        if (values && values.length > 0) {
            const result = values?.map((el: string) => {
                return this.brands?.find((item) => el === item.id);
            });
            return result;
        }
    }

    getPartnerByCode(code: string) {
        return this.partners.find((partner) => partner.id === code);
    }

    getBrandByCodeFilter(code: string) {
        return this.brands?.find((item) => item.id === code);
    }

    /* GET CODE SUB FILTER */
    getSupByCodeFilter(code: string) {
        return this.suppliers?.find((sub) => sub.id === code);
    }

    /* GET CODE ManufactoringCountry FILTER */
    getManufactoringCountryByCodeFilter(code: string) {
        return this.countries?.find((item) => item.id === code);
    }

    /* GET CODE packaging FILTER */
    getPackagingByCodeFilter(code: string) {
        return this.packagings?.find((item) => item.id === code);
    }

    /* GET DEPARTMENT */
    getDepartmentByCodeFilter(code: string) {
        return this.departments?.find((item) => item.id === code);
    }

    get breadCrumb() {
        const hasCategoryModal = this.sessionStorageService
            .getFilters()
            .hasOwnProperty('isCategoryModal');

        this.categoryList;
        let breadCrumbs: BreadCrumbItem[];

        if (this.headerType === fromPATH.marque) {
            breadCrumbs = [
                { name: this.translate.instant('Menu.home'), url: PATHSIRONSIDE.home_en },
                { name: this.translate.instant('Menu.product'), isEnable: false },
                { name: this.translate.instant('Menu.brands'), isEnable: false },
                { name: this.getNameBrand || '' },
            ];
        } else if (this.headerType === fromPATH.supplier) {
            breadCrumbs = [
                { name: this.translate.instant('Menu.home'), url: PATHSIRONSIDE.home_en },
                {
                    name: this.translate.instant('Menu.suppliers'),
                    url: `${PATHSIRONSIDE.suppliers_en}`,
                },
                {
                    name: `${this.translate.instant('Menu.supplier-catalog')} : ${
                        this.getSupplierByCode()?.title || ''
                    }`,
                },
            ];
        } else if (this.headerType === fromPATH.header) {
            breadCrumbs = [
                { name: this.translate.instant('Menu.home'), url: PATHSIRONSIDE.home_en },
                { name: this.translate.instant('Menu.product'), isEnable: false },
                { name: this.translate.instant('Menu.new-product'), isEnable: false },
            ];
        } else if (hasCategoryModal) {
            const hasCatalogName = this.sessionStorageService
                .getFilters()
                .hasOwnProperty('catalogName');
            if (hasCatalogName) {
                breadCrumbs = [
                    { name: this.translate.instant('Menu.home'), url: PATHSIRONSIDE.home_en },
                    { name: this.translate.instant('Menu.product'), isEnable: false },
                    {
                        name: this.translate.instant('Menu.products-catalog'),
                        url: PATHSIRONSIDE.catalogues_en,
                    },
                    { name: this.translate.instant('Menu.categories'), isEnable: false },
                    {
                        name: this.translateDynamicLanguage.transform(
                            this.sessionStorageService.getFilters()?.catalogName
                        ),
                        isEnable: false,
                    },
                ];
            } else {
                breadCrumbs = [
                    { name: this.translate.instant('Menu.home'), url: PATHSIRONSIDE.home_en },
                    { name: this.translate.instant('Menu.product'), isEnable: false },
                    {
                        name: this.translate.instant('Menu.products-catalog'),
                        url: PATHSIRONSIDE.catalogues_en,
                    },
                    { name: this.translate.instant('Menu.categories'), isEnable: false },
                ];
            }
        } else if (this.sessionStorageService.getFilters()?.favListId) {
            breadCrumbs = [
                { name: this.translate.instant('Menu.home'), url: PATHSIRONSIDE.home_en },
                {
                    name: this.translate.instant('Menu.my-favorites'),
                    url: PATHSIRONSIDE.mesFavoris,
                },
                { name: this.favListName, isEnable: false },
            ];
        } else {
            breadCrumbs = [
                { name: this.translate.instant('Menu.home'), url: PATHSIRONSIDE.home_en },
                { name: this.translate.instant('Menu.research'), url: PATHSIRONSIDE.research },
            ];
        }
        return breadCrumbs;
    }

    getSupplierByCode() {
        return this.suppliers?.find((supplier) => supplier.id === this.idSupplier);
    }

    addProductToCompare(id?: string) {
        if (!id) return;

        this.comparatorRepository.addProduct([id]);
    }

    handleLoadLazyData(body?: DynamicProductParam) {
        if (!this.products || !Array.isArray(this.products)) {
            return;
        }

        const validProducts = this.products.filter(
            (product) => product && product.fullExtendData === undefined
        );

        if (validProducts.length === 0) {
            return;
        }
        /* Handle Load Image by List product */
        this.fetchImageProduct(validProducts);
        /* Handle Fetch Product child Table by Product Parent */
        const isOffMarketProduct = this.formFilter.value.isOffMarketProduct;
        this.productRepository
            .loadFullExtendDataByGroup(validProducts, isOffMarketProduct, body)
            .subscribe({
                next: (res) => {
                    this.products = res?.filter((el) => el.fullExtendData?.length ?? 0 > 0);
                    const idSupplier = this.activatedRoute.snapshot?.params?.['supplierId'];
                    if (this.pathCurrentText == 'suppliers/detail/:supplierId') {
                        this.products?.forEach((product) => {
                            if (!product.fullExtendData?.length) {
                                return;
                            }

                            product.fullExtendData.forEach((extendData) => {
                                if (!extendData.prixs?.length) {
                                    return;
                                }

                                extendData.prixs = extendData.prixs.filter((prix) => {
                                    return prix?.linkToSupplier?.documentId === idSupplier;
                                });
                            });
                        });
                    }
                    /* this._commonService
                        .getFlatCategories()
                        .pipe(takeUntil(this.destroyRef))
                        .subscribe((tree) => {
                            const result = buildCategoryHierarchyRandom(tree);
                            this.sortProductListByCategories(this.products!, result);
                        }); */

                    const result = this.getCurrentFilters()?.find(
                        (el) => el.fieldName === 'linkToPartnerReference.value.documentId'
                    );

                    if (result) {
                        this.products = this.products
                            ?.map((pro: any) => {
                                pro.fullExtendData = pro.fullExtendData?.filter(
                                    (full: any) =>
                                        full.partners &&
                                        full.partners.length > 0 &&
                                        full.partners.some((par: any) =>
                                            result.values.includes(par.documentId)
                                        )
                                );
                                return pro;
                            })
                            .filter((el) => el?.fullExtendData?.length ?? 0 > 0);
                    }

                    const fullExtendData = this.products?.flatMap((product) =>
                        product?.fullExtendData?.flatMap((el) => el || [])
                    );

                    // Update quantity cho PDF/EXCEL types (IMAGE types sẽ được update bởi loadResourceQuantities)
                    if (fullExtendData?.length && fullExtendData?.length > 0) {
                        this.exportOption = this.exportOption.map((item) => {
                            if (item?.type === 'PDF' || item?.type === 'EXCEL') {
                                // LOGISTIC_DATA sẽ được set từ API countLogisticsBattery, không set ở đây
                                if (item?.key === 'LOGISTIC_DATA') {
                                    return item;
                                }
                                return {
                                    ...item,
                                    quantity: fullExtendData?.length,
                                };
                            }
                            return item;
                        });
                    }
                    this.selectedChildren =
                        this.sessionStorageService.getItem('selectedChildren') ?? {};
                    // Load resource quantities từ API sau khi load full extend data
                    this.loadResourceQuantities();
                    // Load logistics/battery quantity cho LOGISTIC_DATA
                    this.loadLogisticsBatteryQuantity();
                },
                error: (error) => {
                    console.error('Error loading product data:', error);
                },
            });
    }

    /**
     * Load resource quantities for IMAGE type options using countResourcesByProductIdsGroupByType
     * Gọi getParentIds trước, sau đó gọi countResourcesByProductIdsGroupByType
     */
    async loadResourceQuantities(): Promise<void> {
        // Reset quantities và isDisable cho tất cả IMAGE options
        this.exportOption.forEach((option) => {
            if (option.type === 'IMAGE') {
                option.quantity = 0;
                option.isDisable = true;
            }
        });

        // Kiểm tra có products không
        if (!this.products || this.products.length === 0) {
            return;
        }

        try {
            // Step 1: Kiểm tra xem đã có parentIds cached chưa, nếu có thì dùng lại
            let parentIds: string[] = [];

            if (this.cachedParentIds && this.cachedParentIds.length > 0) {
                // Sử dụng parentIds đã cache
                parentIds = this.cachedParentIds;
            } else {
                // Nếu chưa có cache, gọi getParentIds
                const selectedChildIds = Object.values(this.selectedChildren).flat();
                const hasSelection = Object.keys(this.selectedChildren).length > 0;

                if (hasSelection) {
                    // Nếu có selection, lấy parent IDs từ selectedChildren
                    parentIds = Object.keys(this.selectedChildren).filter(
                        (parentId) => (this.selectedChildren[parentId]?.length || 0) > 0
                    );
                } else {
                    // Nếu không có selection, gọi API getParentIds
                    const filterParentIds = this.getCurrentFilters();
                    const bodyGetParentIds = {
                        filters: this.convertFilterProduct(filterParentIds),
                        fields: this.fields,
                        locales: [
                            environment.languagesExtranet.find(
                                (lang: any) => lang?.code === this.translate.currentLang
                            )?.locale || 'en_GB',
                        ],
                        sorts: { referenceProduct: 'DESC', publishedOrder: 'DESC' },
                    };
                    parentIds = await firstValueFrom(
                        this.dynamicDocumentService.getParentIds(bodyGetParentIds)
                    );
                }

                // Cache parentIds để tái sử dụng
                this.cachedParentIds = parentIds;
            }

            if (!parentIds || parentIds.length === 0) {
                return;
            }

            // Step 2: Get current locale
            const currentLocale =
                environment.languagesExtranet.find(
                    (lang) => lang.code === this.translate.currentLang
                )?.locale || 'en_GB';

            // Step 3: Lấy danh sách IMAGE export options
            const imageExportOptions = this.exportOption.filter((opt) => opt.type === 'IMAGE');
            const hasPhotoOptions = imageExportOptions.some(
                (opt) => opt.key === 'PHOTO' || opt.key === 'PHOTO_THUMBNAIL'
            );

            // Step 4: Nếu có PHOTO options, cần gọi listResourcesByProductIds để phân biệt HR/LR
            if (hasPhotoOptions) {
                // Gọi listResourcesByProductIds để lấy chi tiết resources
                const resourceTypes = [
                    ...new Set(
                        imageExportOptions.map((opt) => this.mapExportKeyToResourceType(opt.key))
                    ),
                ];

                const apiResponse = await firstValueFrom(
                    this.dynamicDocumentService.listResourcesByProductIds(
                        parentIds,
                        resourceTypes,
                        [currentLocale],
                        false
                    )
                );

                const apiResources = Array.isArray(apiResponse)
                    ? apiResponse
                    : apiResponse?.content || [];

                // Đếm quantity cho từng type, phân biệt PHOTO HR và LR dựa trên file[0].hd
                const countMap = new Map<string, number>();
                imageExportOptions.forEach((option) => {
                    const resourceType = this.mapExportKeyToResourceType(option.key);
                    let count = 0;

                    if (option.key === 'PHOTO' || option.key === 'PHOTO_THUMBNAIL') {
                        // Phân biệt PHOTO HR (hd === true) và PHOTO_THUMBNAIL LR (hd === false)
                        const photoResources = apiResources.filter((res: any) => {
                            const resType =
                                res?.typeOfResourceInfo?.valeur ||
                                res?.typeOfResource?.valeur ||
                                res?.typeOfResource?.value ||
                                res?.typeOfResource;
                            return resType === 'PHOTO';
                        });

                        photoResources.forEach((res: any) => {
                            // PHOTO (HR): chỉ đếm khi hd === true
                            if (option.key === 'PHOTO') {
                                const files = res?.file || res?.files || [];
                                const firstFile = files?.[0];
                                const isHd = firstFile?.hd === true;
                                if (isHd) {
                                    count++;
                                }
                            }
                            // PHOTO_THUMBNAIL (LR): đếm tất cả PHOTO resources, không cần kiểm tra hd
                            else if (option.key === 'PHOTO_THUMBNAIL') {
                                count++; // Đếm tất cả, không kiểm tra hd
                            }
                        });
                    } else {
                        // Các type khác, đếm bình thường
                        count = apiResources.filter((res: any) => {
                            const resType =
                                res?.typeOfResourceInfo?.valeur ||
                                res?.typeOfResource?.valeur ||
                                res?.typeOfResource?.value ||
                                res?.typeOfResource;
                            return resType === resourceType;
                        }).length;
                    }

                    countMap.set(option.key, count);
                });

                // Update exportOption với quantities
                this.exportOption.forEach((option) => {
                    if (option.type === 'IMAGE') {
                        const count = countMap.get(option.key) || 0;
                        option.quantity = count;
                        option.isDisable = count === 0;
                    }
                });
            } else {
                // Nếu không có PHOTO options, dùng countResourcesByProductIdsGroupByType
                const countResponse = await firstValueFrom(
                    this.dynamicDocumentService.countResourcesByProductIdsGroupByType(
                        parentIds,
                        [currentLocale],
                        false
                    )
                );

                if (countResponse && Array.isArray(countResponse)) {
                    const countMap = new Map<string, number>();
                    countResponse.forEach((item: any) => {
                        const type = item?.typeOfResource;
                        const count = item?.count || 0;
                        if (type) {
                            countMap.set(type, count);
                        }
                    });

                    this.exportOption.forEach((option) => {
                        if (option.type === 'IMAGE') {
                            const resourceType = this.mapExportKeyToResourceType(option.key);
                            const count = countMap.get(resourceType) || 0;
                            option.quantity = count;
                            option.isDisable = count === 0;
                        }
                    });
                }
            }
        } catch (error) {
            console.error('Error loading resource quantities:', error);
            // Keep default values (quantity = 0, isDisable = true)
        }
    }

    /**
     * Load logistics/battery quantity for LOGISTIC_DATA export option
     * Gọi API countLogisticsBattery để lấy totalCount và set quantity
     */
    async loadLogisticsBatteryQuantity(): Promise<void> {
        try {
            // Step 1: Kiểm tra xem đã có parentIds cached chưa, nếu có thì dùng lại
            let parentIds: string[] = [];

            if (this.cachedParentIds && this.cachedParentIds.length > 0) {
                // Sử dụng parentIds đã cache
                parentIds = this.cachedParentIds;
            } else {
                // Nếu chưa có cache, gọi getParentIds
                const selectedChildIds = Object.values(this.selectedChildren).flat();
                const hasSelection = Object.keys(this.selectedChildren).length > 0;

                if (hasSelection) {
                    // Nếu có selection, lấy parent IDs từ selectedChildren
                    parentIds = Object.keys(this.selectedChildren).filter(
                        (parentId) => (this.selectedChildren[parentId]?.length || 0) > 0
                    );
                } else {
                    // Nếu không có selection, gọi API getParentIds
                    const filterParentIds = this.getCurrentFilters();
                    const bodyGetParentIds = {
                        filters: this.convertFilterProduct(filterParentIds),
                        fields: this.fields,
                        locales: [
                            environment.languagesExtranet.find(
                                (lang: any) => lang?.code === this.translate.currentLang
                            )?.locale || 'en_GB',
                        ],
                        sorts: { referenceProduct: 'DESC', publishedOrder: 'DESC' },
                    };
                    parentIds = await firstValueFrom(
                        this.dynamicDocumentService.getParentIds(bodyGetParentIds)
                    );
                }

                // Cache parentIds để tái sử dụng
                this.cachedParentIds = parentIds;
            }

            if (!parentIds || parentIds.length === 0) {
                // Nếu không có parentIds, set quantity = 0 cho LOGISTIC_DATA
                this.exportOption = this.exportOption.map((item) => {
                    if (item?.key === 'LOGISTIC_DATA') {
                        return {
                            ...item,
                            quantity: 0,
                        };
                    }
                    return item;
                });
                return;
            }

            // Step 2: Tạo body để gọi API countLogisticsBattery
            const body = {
                filters: [
                    {
                        fieldName: 'linkToParentProduct.documentId',
                        conditions: [
                            {
                                type: 'IN',
                                value: parentIds,
                            },
                        ],
                    },
                ],
                fields: this.fields,
                locales: [
                    environment.languagesExtranet.find(
                        (lang: any) => lang?.code === this.translate.currentLang
                    )?.locale || 'en_GB',
                ],
                sorts: {},
                page: 1,
                pageSize: 100,
            };

            // Step 3: Gọi API countLogisticsBattery
            const response = await firstValueFrom(
                this.dynamicDocumentService.countLogisticsBattery(body, false)
            );

            // Step 4: Update quantity cho LOGISTIC_DATA dựa trên totalCount
            if (response && response.totalCount !== undefined) {
                this.exportOption = this.exportOption.map((item) => {
                    if (item?.key === 'LOGISTIC_DATA') {
                        return {
                            ...item,
                            quantity: response.totalCount || 0,
                        };
                    }
                    return item;
                });
            }
        } catch (error) {
            console.error('Error loading logistics/battery quantity:', error);
            // Set quantity = 0 cho LOGISTIC_DATA nếu có lỗi
            this.exportOption = this.exportOption.map((item) => {
                if (item?.key === 'LOGISTIC_DATA') {
                    return {
                        ...item,
                        quantity: 0,
                    };
                }
                return item;
            });
        }
    }

    fetchImageProduct(products: Product[]) {
        const productGroups = [];

        for (let i = 0; i < products.length; i += 10) {
            productGroups.push(products.slice(i, i + 10));
        }

        const observables = productGroups.map((group) => {
            const resourceIds = group.flatMap((product) => product.resources || []);
            return resourceIds.length
                ? this.resourceRepository.getListImageResource(resourceIds)
                : of([]);
        });

        forkJoin(observables)
            .pipe(takeUntil(this.destroyRef))
            .subscribe((results) => {
                const combinedImages = results.flatMap((item) => item);

                products?.forEach((product) => {
                    const matchingImage: Resource | undefined = combinedImages.find(
                        (image) => image?.id === product?.fullExtendData?.[0]?.resources?.[0]
                    );
                    if (matchingImage) {
                        product.image =
                            matchingImage?.files?.[0]?.thumbnailUrl ||
                            matchingImage?.files?.[0]?.url ||
                            '';
                    }
                });
            });
    }

    onToggleIcon(event: any, color: string) {
        const iconURL = `/src-ironside/assets/icons/comparator_${color}.svg`;

        const imgTag = (event.target as HTMLElement)?.querySelector('#comparator-icon');

        if (imgTag) {
            imgTag.setAttribute('src', iconURL);
        }
    }

    resetCategories() {
        this.formFilter?.get('categories')?.setValue(null);
        this.categoryName = '';
    }

    get getNameBrand() {
        return this.idMarque.replace(/_/g, ' ');
    }

    extractValues(tree: any[]): any[] {
        if (!tree) return [];
        return tree?.flatMap((node: any) => {
            const currentNodeValue = node?.codeCategory
                ? [{ type: 'EQUALS', value: node?.codeCategory }]
                : [];

            const subValues = node?.subcategoryList
                ? this.extractValues(node?.subcategoryList)
                : [];
            return [...currentNodeValue, ...subValues];
        });
    }

    extractValuesOrigin(tree: any[]): any[] {
        if (!tree) return [];
        return tree?.flatMap((node: any) => {
            const currentNodeValue = node?.id ? [node?.id] : [];

            const subValues = node?.subcategoryList
                ? this.extractValuesOrigin(node?.subcategoryList)
                : [];
            return [...currentNodeValue, ...subValues];
        });
    }

    extractValuesOriginByCode(tree: any[]): any[] {
        if (!tree) return [];
        return tree?.flatMap((node: any) => {
            const currentNodeValue = node?.codeCategory ? [node?.codeCategory] : [];

            const subValues = node?.subcategoryList
                ? this.extractValuesOrigin(node?.subcategoryList)
                : [];
            return [...currentNodeValue, ...subValues];
        });
    }

    getBodySearchCategoryByFilters() {
        let filters: any = [];

        const searchFormValue = {
            ...this.sessionStorageService.getFilters(),
        };

        if (searchFormValue.research) {
            const research = searchFormValue.research;

            if (research) {
                filters = [...filters, ...getParamSearchFilters(research)];
            }
        }

        /* NEW PRODUCT */
        if (searchFormValue.isNewProduct && searchFormValue.isNewProduct === true) {
            filters.push(
                {
                    fieldName: 'newStartDate',
                    conditions: [
                        {
                            type: 'LESS_THAN',
                            value: getCurrentDate(),
                        },
                    ],
                },
                {
                    fieldName: 'newEndDate',
                    conditions: [
                        {
                            type: 'GREATER_THAN',
                            value: getCurrentDate(),
                        },
                    ],
                },
                {
                    fieldName: 'new',
                    conditions: [
                        {
                            type: 'EQUALS',
                            value: true,
                        },
                    ],
                }
            );
        }

        /* FOURNISSEUR */
        if (searchFormValue.suppliers && searchFormValue.suppliers.length > 0) {
            const conditions = searchFormValue.suppliers.map((el: string) => ({
                type: 'EQUALS',
                value: el,
            }));

            filters.push({
                fieldName: 'linkToSupplier.documentId',
                conditions: conditions,
            });
        }

        /* BRAND */
        if (searchFormValue?.brand && searchFormValue?.brand?.length > 0) {
            const conditions = searchFormValue?.brand?.map((el: string) => ({
                type: 'EQUALS',
                value: el,
            }));

            filters.push({
                fieldName: 'brand.parameterId',
                conditions: conditions,
            });
        }

        const filterStore = this.sessionStorageService.getFilters();
        if (filterStore?.isfavLis) {
            const condition =
                filterStore?.productIdsFav?.length > 0
                    ? filterStore?.productIdsFav
                    : ['00000000000000000000000'];
            if (condition.length > 0) {
                filters.push({
                    fieldName:
                        filterStore?.productIdsFav?.length > 0
                            ? 'linkToParentProduct.documentId'
                            : 'id',
                    conditions: condition.map((el: string) => ({
                        type: 'EQUALS',
                        value: el,
                    })),
                });
            }
        }

        filters.push({
            fieldName: 'statusProduct',
            conditions: [
                {
                    type: 'EQUALS',
                    value: 'VALIDE',
                },
            ],
        });

        return filters;
    }

    getCategoriesByFilter() {
        const filters = this.getBodySearchCategoryByFilters();
        const body: DynamicReferencedFilterParam = {
            page: 1,
            pageSize: 100000,
            fields: ['nameCategory', 'categoryLevelCategory', 'attachmentCategory', 'codeCategory'],
            referencedDocumentName: 'dynamic_product',
            referencedField: 'categoryCode',
            referencedFilters: filters,
            sorts: { nameCategory: 'ASC' },
            referencedLocales: [this.currentLang],
        };
        this.dynamicDocumentService
            .getDynamicReferencedByFilter(body, 'dynamic_category/parents')
            .pipe(takeUntil(this.destroyRef))
            .subscribe({
                next: (resRef: any) => {
                    this._commonService
                        .getCategories()
                        .pipe(takeUntil(this.destroyRef))
                        .subscribe((tree) => {
                            const treeResult = findCategoryLv1ByCategories(tree, resRef?.content);
                            const result = buildCategoryHierarchyRandom(treeResult);
                            this.categories = result.sort((a: any, b: any) =>
                                a.nameCategory?.[this.currentLang].localeCompare(
                                    b.nameCategory?.[this.currentLang]
                                )
                            );
                        });
                },
                error: () => {},
            });
    }

    isCurrentDateInRange(info: ProductExtendInfo): boolean {
        const currentDate = Date.now();
        if (info?.newStartDate && info?.newEndDate && info?.new === true) {
            return currentDate >= info?.newStartDate && currentDate <= info?.newEndDate;
        }
        return false;
    }

    onShowTypeExport() {
        if (
            (this.products?.length ?? 0) > 0 &&
            this.exportOption.some((el) => el?.permission === true)
        ) {
            this.exportVisible = !this.exportVisible;
        }
    }

    get isPermissionAllExport() {
        return this.exportOption.some((el) => el?.permission === true);
    }

    get isExeportVisible() {
        if (
            this.pathCurrentText !== 'new-product' &&
            this.pathCurrentText !== 'research' &&
            this.pathCurrentText !== 'brands/detail/:marqueId' &&
            this.pathCurrentText !== 'suppliers/detail/:supplierId'
        ) {
            return false;
        } else {
            return true;
        }
    }

    getResourceValidData(value: any) {
        if (value?.length) {
            return value?.[0]?.file?.[0]?.thumbnailUrl || value?.[0]?.file?.[0]?.url;
        } else {
            return 'src-ironside/assets/images/image-default.jpg';
        }
    }

    getFilterTranslateBrand(valueArray: any[]) {
        return valueArray
            ?.filter((el) => el?.count > 0)
            ?.map((item) => ({
                ...item,
                translatedTitle: this.translateDynamicLanguage.transform(item.title),
            }))
            .sort((a: any, b: any) => a.translatedTitle.localeCompare(b.translatedTitle));
    }

    getFilterTranslate(valueArray: any[]) {
        return valueArray
            ?.map((item) => ({
                ...item,
                translatedTitle: this.translateDynamicLanguage.transform(item.title),
            }))
            .sort((a: any, b: any) => a.translatedTitle.localeCompare(b.translatedTitle));
    }

    isDisabled(key: string): boolean {
        return this.itemExportSelected?.length >= 3 && !this.itemExportSelected.includes(key);
    }

    progressExport() {
        this.ngZone.runOutsideAngular(() => {
            this.interval = setInterval(() => {
                this.ngZone.run(() => {
                    if (this.loadingExport) {
                        this.progressNumber = Math.min(
                            this.progressNumber + Math.floor(Math.random() * 10) + 8,
                            99
                        );
                    } else {
                        this.progressNumber = Math.min(
                            this.progressNumber + Math.floor(Math.random() * 10) + 8,
                            100
                        );
                        if (this.progressNumber >= 100) {
                            if (this.finalZipBlob) {
                                this.onExport(this.finalZipBlob);
                            }
                        }
                    }
                });
            }, 400);
        });
    }
    finalZipBlob: Blob | null = null;

    private async handleTemplateExport(exportTypes: string, parentIds: string[]): Promise<Blob> {
        return new Promise(async (resolve) => {
            this._commonService
                .getCategories()
                .pipe(
                    filter((el: any) => el && el.length > 0),
                    switchMap(async (el: any) => {
                        this.categoriesFlat = el;
                        const hasSelection = Object.keys(this.selectedChildren).length > 0;

                        let filter = this.getCurrentFilters();

                        if (hasSelection) {
                            // chỉ lấy parentId có ít nhất 1 item con được chọn
                            const idsParentItem = Object.keys(this.selectedChildren).filter(
                                (parentId) => (this.selectedChildren[parentId]?.length || 0) > 0
                            );

                            // gom tất cả các id con
                            const idsChildItem: string[] = Object.values(this.selectedChildren)
                                .flat()
                                .filter((id): id is string => !!id); // lọc undefined/null

                            filter.push(
                                {
                                    fieldName: 'linkToParentProduct.documentId',
                                    values: idsParentItem,
                                },
                                {
                                    fieldName: 'childProduct.documentId',
                                    values: idsChildItem,
                                }
                            );
                        } else {
                            // Sử dụng parentIds đã được truyền vào thay vì gọi API lại
                            filter.push({
                                fieldName: 'linkToParentProduct.documentId',
                                values: parentIds,
                            });
                        }

                        let templateTypes;
                        switch (exportTypes) {
                            case 'CATALOGUE':
                                templateTypes = 'EXPORT_PRODUCT_PRICES';
                                break;
                            case 'CATALOGUE_NO_PRICE':
                                templateTypes = 'EXPORT_PRODUCT_WITHOUT_PRICES';
                                break;
                            case 'CATALOGUE_DATA_SHEET':
                                templateTypes = 'EXPORT_PRODUCT_LOGISTICS';
                                break;
                            case 'PRICE':
                                if (
                                    this.permissionService.isPermissionFonction('visibilite-tarifs')
                                ) {
                                    templateTypes = 'EXPORT_PRODUCT_PRICES';
                                } else {
                                    templateTypes = 'EXPORT_PRODUCT_WITHOUT_PRICES';
                                }
                                break;
                            case 'LOGISTIC_DATA':
                                templateTypes = 'EXPORT_PRODUCT_LOGISTICS';
                                break;
                        }

                        const body = {
                            filters: this.convertFilterProduct(filter, true),
                            fields: this.fields,
                            locales: [
                                environment.languagesExtranet.find(
                                    (lang) => lang.code === this.translate.currentLang
                                )?.locale || 'en_GB',
                            ],
                            sorts: {},
                            page: 1,
                            pageSize: 100,
                            exportType: templateTypes,
                            /*  hideFields: hideFields, */
                        };

                        const templateType =
                            exportTypes.includes('CATALOGUE') ||
                            exportTypes.includes('CATALOGUE_NO_PRICE') ||
                            exportTypes.includes('CATALOGUE_DATA_SHEET')
                                ? 'pdf'
                                : 'xlsx';

                        return firstValueFrom(
                            this.dynamicDocumentService.exportProductByTemplate(body, templateType)
                        );
                    })
                )
                .subscribe({
                    next: (res) => {
                        resolve(res);
                    },
                    error: (error) => {
                        const exportOption = this.exportOption.find(
                            (el) => el?.key === exportTypes
                        );
                        this._messageService.add({
                            severity: 'error',
                            detail: this.translate.instant('export.FILE_EXPORT_ERROR', {
                                type: this.translate.instant('export.' + exportOption?.label),
                            }),
                        });
                        resolve(null as any);
                    },
                });
        });
    }

    async onExportResource() {
        this.isExportCancelled = false;
        this.loadingExport = true;
        this.isProgress = true;
        this.progressExport();

        // Step 1: Kiểm tra xem đã có parentIds cached chưa, nếu có thì dùng lại
        let parentIds: string[] = [];
        try {
            if (this.cachedParentIds && this.cachedParentIds.length > 0) {
                // Sử dụng parentIds đã cache
                parentIds = this.cachedParentIds;
            } else {
                // Nếu chưa có cache, gọi getParentIds
                const selectedChildIds = Object.values(this.selectedChildren).flat();
                const hasSelection = Object.keys(this.selectedChildren).length > 0;

                if (hasSelection) {
                    // Nếu có selection, lấy parent IDs từ selectedChildren
                    const idsParentItem = Object.keys(this.selectedChildren).filter(
                        (parentId) => (this.selectedChildren[parentId]?.length || 0) > 0
                    );
                    parentIds = idsParentItem;
                } else {
                    // Nếu không có selection, gọi API getParentIds
                    const filterParentIds = this.getCurrentFilters();
                    const bodyGetParentIds = {
                        filters: this.convertFilterProduct(filterParentIds),
                        fields: this.fields,
                        locales: [
                            environment.languagesExtranet.find(
                                (lang: any) => lang?.code === this.translate.currentLang
                            )?.locale || 'en_GB',
                        ],
                        sorts: { referenceProduct: 'DESC', publishedOrder: 'DESC' },
                    };
                    parentIds = await firstValueFrom(
                        this.dynamicDocumentService.getParentIds(bodyGetParentIds)
                    );
                }

                // Cache parentIds để tái sử dụng
                this.cachedParentIds = parentIds;
            }
        } catch (error) {
            console.error('Error getting parent IDs:', error);
            this.loadingExport = false;
            this.isProgress = false;
            this.progressNumber = 0;
            clearInterval(this.interval);
            this._messageService.add({
                severity: 'error',
                detail:
                    this.translate.instant('export.ERROR_GETTING_PARENT_IDS') ||
                    'Error getting parent product IDs',
            });
            return;
        }

        if (!parentIds || parentIds.length === 0) {
            this.loadingExport = false;
            this.isProgress = false;
            this.progressNumber = 0;
            clearInterval(this.interval);
            this._messageService.add({
                severity: 'warn',
                detail:
                    this.translate.instant('export.NO_PARENT_IDS') || 'No parent product IDs found',
            });
            return;
        }

        const selectedChildIds = Object.values(this.selectedChildren).flat();
        const isUsingSelection = selectedChildIds.length > 0;

        const templateExports = this.itemExportSelected.filter((type) =>
            TEMPLATE_EXPORT_TYPES.includes(type)
        );
        const regularExports = this.itemExportSelected.filter(
            (type) => !TEMPLATE_EXPORT_TYPES.includes(type)
        );

        const mappedArrays = regularExports.reduce((acc, key) => {
            acc[key] = [];
            return acc;
        }, {} as Record<string, any[]>);

        // Step 2: Xử lý image exports với API mới
        const imageExportOptions = this.getImageExportOptions();
        const nonImageExports = regularExports.filter((key) => !imageExportOptions.includes(key));

        let imageApiSuccess = false;

        if (imageExportOptions.length > 0) {
            try {
                // Step 3: Lấy type được select (những type thuộc IMAGE)
                const resourceTypes = [
                    ...new Set(
                        imageExportOptions.map((key) => this.mapExportKeyToResourceType(key))
                    ),
                ];

                // Get current locale
                const currentLocale =
                    environment.languagesExtranet.find(
                        (lang) => lang.code === this.translate.currentLang
                    )?.locale || 'en_GB';

                // Step 4: Call listResourcesByProductIds với parentIds và resourceTypes
                const apiResponse = await firstValueFrom(
                    this.dynamicDocumentService.listResourcesByProductIds(
                        parentIds,
                        resourceTypes,
                        [currentLocale],
                        false
                    )
                );

                // Step 5: Xử lý response và trả về resource để export
                const apiResources = Array.isArray(apiResponse)
                    ? apiResponse
                    : apiResponse?.content || [];

                if (apiResources && Array.isArray(apiResources) && apiResources.length > 0) {
                    imageExportOptions.forEach((exportKey) => {
                        const resourceType = this.mapExportKeyToResourceType(exportKey);

                        // Filter resources dựa vào typeOfResource
                        // typeOfResource có thể là: typeOfResourceInfo.valeur hoặc typeOfResource.valeur
                        let filteredResources = apiResources.filter((res: any) => {
                            const resType =
                                res?.typeOfResourceInfo?.valeur ||
                                res?.typeOfResource?.valeur ||
                                res?.typeOfResource?.value ||
                                res?.typeOfResource;
                            return resType === resourceType;
                        });

                        // Đối với PHOTO và PHOTO_THUMBNAIL, phân biệt dựa trên file[0].hd
                        if (exportKey === 'PHOTO' || exportKey === 'PHOTO_THUMBNAIL') {
                            filteredResources = filteredResources.filter((res: any) => {
                                // PHOTO (HR): chỉ lấy khi hd === true
                                if (exportKey === 'PHOTO') {
                                    const files = res?.file || res?.files || [];
                                    const firstFile = files[0];
                                    const isHd = firstFile?.hd === true;
                                    return isHd;
                                }
                                // PHOTO_THUMBNAIL (LR): lấy tất cả PHOTO resources, không cần kiểm tra hd
                                else if (exportKey === 'PHOTO_THUMBNAIL') {
                                    return true; // Lấy tất cả, không kiểm tra hd
                                }
                                return false;
                            });
                        }

                        // Normalize resource format để match với format expected
                        const normalizedResources = filteredResources.map((res: any) => {
                            // file là array trong response
                            const files = res?.file || res?.files || [];
                            return {
                                ...res,
                                files: files.map((file: any) => ({
                                    id: file?.id || file?.resourceFileId,
                                    name: file?.name,
                                    url: file?.url,
                                    thumbnailUrl: file?.thumbnailUrl,
                                    hd: file?.hd, // Giữ lại thông tin hd
                                })),
                                // Normalize typeOfResource để dễ xử lý sau này
                                typeOfResource:
                                    res?.typeOfResourceInfo?.valeur ||
                                    res?.typeOfResource?.valeur ||
                                    res?.typeOfResource?.value ||
                                    res?.typeOfResource,
                            };
                        });

                        if (exportKey === 'PHOTO_THUMBNAIL') {
                            mappedArrays.PHOTO_THUMBNAIL = normalizedResources.map((el: any) => ({
                                ...el,
                                files: el?.files?.map((file: any) => ({
                                    ...file,
                                    url: file?.thumbnailUrl || file?.url,
                                })),
                            }));
                        } else {
                            mappedArrays[exportKey] = normalizedResources;
                        }
                    });
                    imageApiSuccess = true;
                }
            } catch (error) {
                console.error('Error fetching resources from API:', error);
                this._messageService.add({
                    severity: 'warn',
                    summary: this.translate.instant('export.WARNING') || 'Warning',
                    detail:
                        this.translate.instant('export.API_FALLBACK_MESSAGE') ||
                        'Using fallback method for image exports',
                });
                imageApiSuccess = false;
            }
        }

        // Step 6: Xử lý non-image exports và fallback cho image exports
        const exportsToProcessWithOldLogic = imageApiSuccess ? nonImageExports : regularExports;

        if (exportsToProcessWithOldLogic.length > 0) {
            let resource: Resource[] = [];
            if (isUsingSelection) {
                resource =
                    this.products?.flatMap((product) =>
                        product?.fullExtendData
                            ?.filter((child) => selectedChildIds.includes(child?.id ?? ''))
                            ?.flatMap((child) => child.resources || [])
                    ) || [];
            } else {
                resource =
                    this.products?.flatMap((product) =>
                        product?.fullExtendData?.flatMap((child) => child.resources || [])
                    ) || [];
            }

            exportsToProcessWithOldLogic.forEach((item) => {
                if (item === 'PHOTO_THUMBNAIL') {
                    mappedArrays.PHOTO_THUMBNAIL = resource
                        .filter((el) => el?.typeOfResource === 'PHOTO')
                        .map((el) => ({
                            ...el,
                            files: el?.files?.map((file: any) => ({
                                ...file,
                                url: file?.thumbnailUrl || file?.url,
                            })),
                        }));
                } else {
                    mappedArrays[item] = resource.filter((el) => el?.typeOfResource === item);
                }
            });
        }

        // Create array of promises for both template and regular exports
        const exportPromises = [
            // Add template export promises (truyền parentIds vào)
            ...templateExports.map((type) =>
                this.handleTemplateExport(type, parentIds).catch((error) => {
                    const exportOption = this.exportOption.find((el) => el?.key === type);
                    this._messageService.add({
                        severity: 'error',
                        detail: this.translate.instant('export.DOWNLOAD_ERROR', {
                            item: exportOption?.label,
                        }),
                    });
                    throw error;
                })
            ),
            // Add regular export promises
            ...Object.entries(mappedArrays).map(([_, resources], index) =>
                downloadAllResource(resources as any).catch((error) => {
                    const exportOption = this.exportOption.find(
                        (el) => el?.key === Object.keys(mappedArrays)[index]
                    );
                    this._messageService.add({
                        severity: 'error',
                        detail: this.translate.instant('export.DOWNLOAD_ERROR', {
                            item: exportOption?.label,
                        }),
                    });
                    throw error;
                })
            ),
        ];

        Promise.allSettled(exportPromises)
            .then((results) => {
                if (this.isExportCancelled) return;

                const finalZip = new JSZip();
                let successCount = 0;
                let errorCount = 0;

                results.forEach((result, index) => {
                    const exportType =
                        index < templateExports.length
                            ? templateExports[index]
                            : Object.keys(mappedArrays)[index - templateExports.length];

                    const exportOption = this.exportOption.find((el) => el?.key === exportType);

                    if (result.status === 'fulfilled' && result.value) {
                        if (TEMPLATE_EXPORT_TYPES.includes(exportType)) {
                            finalZip.file(
                                `${this.translate.instant('export.' + exportOption?.label)}.${
                                    exportType.includes('CATALOGUE') ||
                                    exportType.includes('CATALOGUE_NO_PRICE') ||
                                    exportType.includes('CATALOGUE_DATA_SHEET')
                                        ? 'pdf'
                                        : 'xlsx'
                                }`,
                                result.value
                            );
                        } else {
                            finalZip.file(
                                `${this.translate.instant('export.' + exportOption?.label)}.zip`,
                                result.value
                            );
                        }
                        successCount++;
                    } else {
                        errorCount++;
                    }
                });

                this.progressNumber = 100;
                clearInterval(this.interval);

                if (this.isExportCancelled) return;

                if (successCount === 0) {
                    this.loadingExport = false;
                    this.isProgress = false;
                    this.progressNumber = 0;
                    return;
                }

                return finalZip.generateAsync({ type: 'blob' });
            })
            .then((finalZipBlob) => {
                if (this.isExportCancelled || !finalZipBlob) return;

                this.finalZipBlob = finalZipBlob;
                this.loadingExport = false;

                if (this.progressNumber >= 100) {
                    this.onExport(this.finalZipBlob);
                }
            })
            .catch((error) => {
                this.loadingExport = false;
                this.isProgress = false;
                this.progressNumber = 0;
                clearInterval(this.interval);
            });
    }

    onExport(finalZipBlob: Blob) {
        let nameFile = '';
        if (this.itemExportSelected?.length > 1) {
            this.itemExportSelected?.forEach((item) => {
                const exportOption = this.exportOption.find((el) => el?.key === item);
                if (exportOption) {
                    nameFile += this.translate.instant('export.' + exportOption.label) + '_';
                }
            });
        } else if (this.itemExportSelected?.length === 1) {
            const exportOption = this.exportOption.find(
                (el) => el?.key === this.itemExportSelected[0]
            );
            if (exportOption) {
                nameFile += this.translate.instant('export.' + exportOption.label);
            }
        }
        const zipUrl = URL.createObjectURL(finalZipBlob);
        const a = document.createElement('a');
        a.href = zipUrl;
        a.download = `${nameFile}.zip`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(zipUrl);
        this.isProgress = false;
        this.progressNumber = 0;
        clearInterval(this.interval);
    }

    /**
     * Get list of export options that have type IMAGE
     * @returns Array of export option keys with type IMAGE
     */
    private getImageExportOptions(): string[] {
        return this.itemExportSelected.filter((key) => {
            const option = this.exportOption.find((el) => el?.key === key);
            return option?.type === 'IMAGE';
        });
    }

    /**
     * Map export key to resource type for API call
     * @param key - Export option key
     * @returns Resource type string
     */
    private mapExportKeyToResourceType(key: string): string {
        // PHOTO and PHOTO_THUMBNAIL both map to 'PHOTO'
        if (key === 'PHOTO' || key === 'PHOTO_THUMBNAIL') {
            return 'PHOTO';
        }
        // Other keys remain the same
        return key;
    }

    /**
     * Sorts the given list of products based on their category hierarchy order (lv1 → lv2 → lv3)
     * using the `orderCategory` field from the provided category tree.
     *
     * @param products - List of products to be sorted. Each product must contain a `categoryCode`.
     * @param categories - Hierarchical category structure, where each category may contain a list of subcategories.
     *
     * @returns A new list of products sorted by the `orderCategory` from level 1 to level 3 of the category path.
     */
    sortProductListByCategories(products: Product[], categories: Category[]): Product[] {
        /**
         * Recursively finds the full category path (e.g., [lv1, lv2, lv3]) for a given category code.
         *
         * @param categories - The current level of the category tree to search.
         * @param codeCategory - The code of the category to find.
         * @param path - The path accumulated so far (used for recursion).
         *
         * @returns An array of Category objects representing the full path to the matched category,
         *          or `null` if not found.
         */
        function findCategoryPathByCode(
            categories: Category[],
            codeCategory: string,
            path: Category[] = []
        ): Category[] | null {
            for (const category of categories) {
                const currentPath = [...path, category];

                // Found matching category
                if (category.codeCategory === codeCategory) {
                    return currentPath;
                }

                // Continue search recursively in subcategories
                if (category.subcategoryList?.length) {
                    const result = findCategoryPathByCode(
                        category.subcategoryList,
                        codeCategory,
                        currentPath
                    );
                    if (result) return result;
                }
            }

            // Not found
            return null;
        }

        // Map each product to its categoryPath (array of [lv1, lv2, lv3])
        products.forEach((product) => {
            const categoryPath = findCategoryPathByCode(categories, product.categoryCode);
            if (categoryPath) {
                product['categoryPath'] = categoryPath;
            }
        });

        /**
         * Sort the products by comparing orderCategory at level 1 → 2 → 3
         */
        const currentLang =
            environment.languagesExtranet.find((lang) => lang.code === this.translate.currentLang)
                ?.locale || 'en_GB';

        /* products.sort((a: any, b: any) => {
            for (let level = 0; level < 3; level++) {
                const orderA = a?.categoryPath?.[level]?.orderCategory;
                const orderB = b?.categoryPath?.[level]?.orderCategory;

                // If both undefined/null, skip to next level
                if (orderA == null && orderB == null) continue;

                // If one side is missing, treat it as larger (push it to the end)
                if (orderA == null) return 1;
                if (orderB == null) return -1;

                // If values differ, return the comparison result
                if (orderA !== orderB) {
                    return orderA - orderB;
                }
            }

            // If all levels are equal, sort by orderNumber
            // Nếu cả hai có orderNumber, sắp xếp theo orderNumber
            if (a?.orderNumber != null && b?.orderNumber != null) {
                return a.orderNumber - b.orderNumber;
            }

            // Nếu chỉ a có orderNumber, a đứng trước
            if (a?.orderNumber != null && b?.orderNumber == null) {
                return -1;
            }

            // Nếu chỉ b có orderNumber, b đứng trước
            if (a?.orderNumber == null && b?.orderNumber != null) {
                return 1;
            }

            // Nếu cả hai đều null, sắp xếp theo bảng chữ cái theo title
            if (a?.orderNumber == null && b?.orderNumber == null) {
                const titleA = (a?.shortDescription?.[currentLang] || '').toLowerCase();
                const titleB = (b?.shortDescription?.[currentLang] || '').toLowerCase();
                return titleA.localeCompare(titleB);
            }

            return 0;
        }); */

        return products;
    }

    convertTariffs(tariffs?: any[]) {
        return (
            tariffs
                ?.filter((t: any) => t.price)
                ?.map((t: any) => {
                    const startDate = t.applicationStartDate
                        ? this.datePipe.transform(t.applicationStartDate, 'dd-MM-yyyy')
                        : '';

                    const endDate = t.applicationEndDate
                        ? this.datePipe.transform(t.applicationEndDate, 'dd-MM-yyyy')
                        : '';

                    const dateText = [startDate, endDate].filter(Boolean).join(' / ') || '_';

                    const incoterm =
                        this.translateDynamicLanguage.transform(t.incoterm?.labels) || '';
                    const typePackaging =
                        this.translateDynamicLanguage.transform(t.typeOfPackaging?.labels) || '';
                    const moq = t.moq ? `${t.moq}pcs` : '';
                    const place = t.placeIncoterm || '';
                    const priceText = `${t.price.toFixed(2)} ${
                        t.currency ? TariffRepository.mapCurrencyText(t.currency) : ''
                    } `;
                    const incotermText = [incoterm, place, moq, typePackaging]
                        .filter(Boolean)
                        .join(' ');

                    return [
                        priceText.trim(),
                        incotermText.trim(),
                        `${dateText}`.trim(),
                        t.linkToSupplier,
                    ];
                }) || []
        );
    }

    openDialog() {
        this.visibleDialog = true;
    }

    onCancelExport() {
        this.isExportCancelled = true;
        this.exportVisible = false;
        this.loadingExport = false;
        this.isProgress = false;
        this.progressNumber = 0;
        this.itemExportSelected = [];
        this.finalZipBlob = null;
        clearInterval(this.interval);
    }

    onRedirectToSupplier(supplier: string) {
        this.router.navigateByUrl(`suppliers/detail-supplier/${supplier}`);
    }
    onRedirectToProductDetail(ref: string) {
        window.open(`product/detail/${ref}`, '_blank');
    }

    onCategoryCheckboxChange(
        checked: boolean,
        category: any,
        parent?: any,
        grandParent?: any
    ): void {
        const setChecked = (cat: any, value: boolean) => {
            this.categoriesCheckedMap[cat.id] = value;
            cat.subcategoryList?.forEach((sub: any) => setChecked(sub, value));
        };

        const isAllChecked = (list: any[]) =>
            list?.every((c: any) => this.categoriesCheckedMap[c.id]);

        // Assign status to category and its children
        setChecked(category, checked);

        // Update parent status if needed
        if (parent && grandParent) {
            this.categoriesCheckedMap[parent.id] = isAllChecked(parent.subcategoryList);
            this.categoriesCheckedMap[grandParent.id] = isAllChecked(grandParent.subcategoryList);
        } else if (parent) {
            this.categoriesCheckedMap[parent.id] = isAllChecked(parent.subcategoryList);
        }

        this.updateCategoriesCheckedArray();
        this.formFilter.patchValue({ categories: this.getSelectedCategoryIds() });
    }

    updateCategoriesCheckedArray(): void {
        this.categoriesChecked = {
            ...this.categoriesChecked,
            id: this.getSelectedCategoryIds(),
        };
    }

    getSelectedCategoryIds(): string[] {
        return Object.entries(this.categoriesCheckedMap)
            .filter(([_, checked]) => checked)
            .map(([id]) => id);
    }

    isExpanded(category: Category): boolean {
        const categoryId: string[] = [category?.id!];

        function findCategory(category: Category) {
            category?.subcategoryList?.forEach((el: any) => {
                categoryId.push(el?.id!);
                if (el?.subcategoryList?.length > 0) {
                    findCategory(el);
                }
            });
        }

        findCategory(category);
        return this.categoriesChecked?.id?.some((el) => categoryId?.includes(el));
    }

    get displayCategories(): CategoryChecked[] {
        const selectedIds: string[] = this.formFilter.get('categories')?.value || [];
        const flat: CategoryChecked[] = flatCategories(this.categories);
        const result: CategoryChecked[] = [];

        for (const category of flat) {
            const isParent = category.categoryLevelCategory === 1;
            if (isParent) {
                const children: any[] = category.subcategoryList || [];
                const childIds: string[] = children.map((child: CategoryChecked) => child.id);
                const selectedChildIds = childIds.filter((id: string) => selectedIds.includes(id));
                const isParentSelected = selectedIds.includes(category.id);

                if (isParentSelected && selectedChildIds.length === childIds.length) {
                    // Parent is selected and all children are also selected → only show parent
                    result.push(category);
                } else if (isParentSelected && selectedChildIds.length < childIds.length) {
                    // Father is selected but has children left out → show father and children left out
                    result.push(category);
                    const unselectedChildIds = childIds.filter(
                        (id: string) => !selectedIds.includes(id)
                    );
                    const unselectedChildren = children.filter((child: CategoryChecked) =>
                        unselectedChildIds.includes(child.id)
                    );
                    result.push(...unselectedChildren);
                } else if (!isParentSelected && selectedChildIds.length > 0) {
                    // Select only a few children (parents are not selected) → show each child
                    const selectedChildren = children.filter((child: CategoryChecked) =>
                        selectedChildIds.includes(child.id)
                    );
                    result.push(...selectedChildren);
                }
            }
        }

        return result;
    }

    resetAllChecked(): void {
        // 1. Reset all checkbox states
        /* Object.keys(this.categoriesCheckedMap).forEach((id) => {
            this.categoriesCheckedMap[id] = false;
        }); */

        // 2. Delete all display tags
        this.sessionStorageService.setFilters({
            ...this.sessionStorageService.getFilters(),
            /*  categories: [], */
            brand: [],
            isNewProduct: false,
            isOffMarketProduct: false,
            manufactoringCountry: [],
            packaging: [],
            suppliers: [],
            partners: [],
        });
        /* setTimeout(() => {
            this.formFilter.get('categories')?.setValue([]);
        }); */
    }

    /* Checkbox export */
    selectedChildren: { [parentId: string]: string[] } = {};
    get totalSelected(): number {
        return Object.values(this.selectedChildren || {}).reduce(
            (acc, arr) => acc + (arr?.length || 0),
            0
        );
    }

    isChildSelected(parentId: string, childId: string | undefined): boolean {
        if (!childId) return false; // nếu id là undefined thì mặc định chưa được chọn
        return this.selectedChildren[parentId]?.includes(childId) ?? false;
    }

    toggleChildSelection(checked: boolean, parentId: string, child: ProductExtendInfo): void {
        const childId = child.id;
        if (!childId) return;

        if (!this.selectedChildren[parentId]) {
            this.selectedChildren[parentId] = [];
        }

        const list = this.selectedChildren[parentId];

        if (checked) {
            if (!list.includes(childId)) {
                list.push(childId);
            }
        } else {
            this.selectedChildren[parentId] = list.filter((id) => id !== childId);
            if (this.selectedChildren[parentId].length === 0) {
                delete this.selectedChildren[parentId];
            }
        }
        if (Object.keys(this.selectedChildren).length > 0) {
            this.sessionStorageService.setItem('selectedChildren', this.selectedChildren);
        } else {
            this.sessionStorageService.removeItem('selectedChildren');
        }
        this.initActiveExport();
    }

    isAllSelected(parentId: string, children: ProductExtendInfo[]): boolean {
        const selected = this.selectedChildren[parentId] || [];
        const childIds = children.map((child) => child.id).filter((id): id is string => !!id);
        return selected.length > 0 && selected.length === childIds.length;
    }

    isIndeterminate(parentId: string, children: ProductExtendInfo[]): boolean {
        const selected = this.selectedChildren[parentId] || [];
        const childIds = children.map((child) => child.id).filter((id): id is string => !!id);
        return selected.length > 0 && selected.length < childIds.length;
    }

    toggleSelectAll(checked: boolean, parentId: string, children: ProductExtendInfo[]): void {
        if (checked) {
            this.selectedChildren[parentId] = children
                .map((child) => child.id)
                .filter((id): id is string => !!id);
        } else {
            delete this.selectedChildren[parentId];
        }
        this.initActiveExport();

        if (Object.keys(this.selectedChildren).length > 0) {
            this.sessionStorageService.setItem('selectedChildren', this.selectedChildren);
        } else {
            this.sessionStorageService.removeItem('selectedChildren');
        }
    }

    onCancelSelectedProduct() {
        this.selectedChildren = {};
    }

    initActiveExport() {
        const selectedChildIds: string[] = Object.values(this.selectedChildren || {}).flat();
        let filteredFullExtendData: ProductExtendInfo[] = [];
        if (selectedChildIds?.length > 0) {
            filteredFullExtendData =
                this.products?.flatMap(
                    (product) =>
                        product?.fullExtendData?.filter((el) =>
                            selectedChildIds.includes(el?.id ?? '')
                        ) || []
                ) || [];
        } else {
            filteredFullExtendData = this.products?.flatMap(
                (product) => product?.fullExtendData || []
            ) as ProductExtendInfo[];
        }

        const filteredResources = filteredFullExtendData.flatMap((el) => el?.resources || []);

        if (filteredResources.length > 0) {
            this.exportOption = this.exportOption.map((el) => {
                /* return {
                    ...el,
                    quantity: (() => {
                        return filteredResources.filter((item) => {
                            if (el?.key === 'PHOTO_THUMBNAIL') {
                                return item?.typeOfResource === 'PHOTO';
                            } else {
                                return item?.typeOfResource === el.key;
                            }
                        }).length;
                    })(),
                }; */
                if (el.type === 'IMAGE') {
                    const matchedResources = filteredFullExtendData
                        .flatMap((item) => item.resources || [])
                        .filter((res) => {
                            if (el.key === 'PHOTO_THUMBNAIL') {
                                return res?.typeOfResource === 'PHOTO';
                            }
                            return res?.typeOfResource === el.key;
                        });

                    return {
                        ...el,
                        quantity: matchedResources.length,
                        items: matchedResources, // gán lại matched resource
                    };
                }

                return el; // giữ nguyên các option khác
            });
        } else {
            this.exportOption = this.exportOption.map((option) => {
                if (option.type === 'IMAGE') {
                    return {
                        ...option,
                        quantity: 0,
                        items: [],
                    };
                }

                return option; // giữ nguyên các option khác
            });
        }

        if (filteredFullExtendData.length) {
            this.exportOption = this.exportOption.map((item) => {
                if (item?.type === 'PDF' || item?.type === 'EXCEL') {
                    // LOGISTIC_DATA sẽ được set từ API countLogisticsBattery, không set ở đây
                    if (item?.key === 'LOGISTIC_DATA') {
                        return item;
                    }
                    return {
                        ...item,
                        quantity: filteredFullExtendData.length,
                    };
                }
                return item;
            });
        }

        // Load logistics/battery quantity cho LOGISTIC_DATA
        this.loadLogisticsBatteryQuantity();

        // Check permission export ảnh
        this._commonService.getExtranetRestrictionsStore().subscribe((res) => {
            const isPermissionImg = res?.fonctions?.includes('export-images') ?? true;

            if (!isPermissionImg) {
                this.exportOption.forEach((el) => {
                    if (el.key === 'PHOTO' || el.key === 'PHOTO_THUMBNAIL') {
                        el.permission = false;
                    }
                });
            }

            Object.entries(functionToExportKey).forEach(([fonctionKey, exportKey]) => {
                this.updateExportPermission(res?.fonctions, fonctionKey, exportKey);
            });
        });
    }
}
